import React, { useCallback, useEffect, useState } from "react";
import chatIcon from "../../../../../imgs/chatIcon.svg";
import { Checkbox, DatePicker, Select, Upload } from "antd";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import PSRejectModal from "./psReject";
import ErrorModal from "../../../../Merchant/Modals/errorModal";
import SuccessModal from "../../../../Merchant/Modals/successModal";
import FeedBackModal from "./feedback";
import VerifyOrder from "../../../cart/verifyOrder";
import dayjs from "dayjs";
import PaymentModal from "./payment";
import {
  DeleteFilled,
  PlusCircleFilled,
  UploadOutlined,
} from "@ant-design/icons";

let file;
let TotalAmount = 0;
let TotalDiscount = 0;
let TotalNetAmount = 0;
let TotalTaxAmount = 0;
let TotalDelivery = 0;
let totalSubTotal = 0;
const Main = () => {
  // const dispatch=useDispatch()
  const [paidAmount,setPaidAmount]=useState(0)
  const [makePayment, setMakePayment] = useState(false);
  const PsOrders = useSelector((state) => state.PsOrders);
  const dispatch = useDispatch();
  const [receivingDate, setReceivingDate] = useState(null);
  const QuotationFlow = useSelector((state) => state.QuotationFlow);
  const dataUser = useSelector((state) => state.dataUser);
  const buyerUserId = dataUser?.data?.user?.id;
  // console.log(dataUser)
  const defaultImage =
    "https://t3.ftcdn.net/jpg/03/45/05/92/360_F_345059232_CPieT8RIWOUk4JqBkkWkIETYAkmz2b75.jpg";
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const OrderData = useSelector((state) => state.OrderData);
  const [note, setNote] = useState("");
  const [errorModal, setErrorModal] = useState(false);
  const [err, setErr] = useState("");
  const [data, setData] = useState();
  const [partialOrder, setPartialOrder] = useState(false);
  const [quantitySending, setQuantitySending] = useState(100);
  const role = useSelector((state) => state.role);
  const user = useSelector((state) => state.user);
  const token = useSelector((state) => state.token);
  const router = useNavigate();
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const [showVerify, setShowVerify] = useState(false);
  const [signature, setSignature] = useState("");
  const [refetch, setRefetch] = useState("");
  const [display, setDisplay] = useState(null);
  const [profileData, setProfileData] = useState({
    logo: "data:image/jpeg;base64,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",
    name: "",
    phone: "",
    email: "",
  });
  const profileData2 = useSelector((state) => state.profileData);
  const [quotationData, setQuotationData] = useState(null);

  const [placeOrderProfileData, setPlaceOrderProfileData] = useState({
    logo: "data:image/jpeg;base64,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",
    name: "",
    phone: "",
    email: "",
  });

  const [address, setAddress] = useState({
    address: "",
    city: "",
    regionName: "",
    regionNo: "",
    ward: "",
    lot: "",
    type: "",
    name: "",
    location: null,
  });

  const updateQuotationData = useCallback((id, updates) => {
    setQuotationData((prev) => ({
      ...prev,
      invOrderItems: prev.invOrderItems.map((orderItem) =>
        orderItem.id === id ? { ...orderItem, ...updates } : orderItem
      ),
    }));
  }, []);

  const [courierName, setCourierName] = useState(null); // Required for "shipped"
  const [courierReceiptNo, setCourierReceiptNo] = useState(""); // Required for "shipped"
  const [courierReceiptImg, setCourierReceiptImg] = useState(null); // Required for "delivered"
  const [deliveryDate, setDeliveryDate] = useState(null);
  const [route, setRoute] = useState("");
  const [imageURL, setImageURL] = useState(null); // To display the image
  const [alteredPrices, setAlteredPrices] = useState([]);
  const [inventoryItems, setInventoryItems] = useState([]);

  useEffect(() => {
    if (user === "vendor-owner") {
      return;
    }
    if (profileData2?.employeeInfo) {
      const data = profileData2?.employeeInfo;

      setSignature(data?.signature);
      const body = [data?.signature];
      if (data?.signature) {
        axios
          .post(
            `${process.env.REACT_APP_BASE_URL}/v1/file/get-image-url?fileType=document`,
            {
              fileNames: body,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((data) => {
            setDisplay(data?.data?.[0]?.url);
          })
          .catch(() => {});
      }
    }
  }, [profileData]);
  useEffect(() => {
    if (OrderData?.user) {
      setPlaceOrderProfileData({
        logo: `${OrderData?.user?.person?.image || ""} `,
        name: `${OrderData?.user?.person?.firstName || ""} ${
          OrderData?.user?.person?.lastName || ""
        }`.trim(),
        phone:
          `${OrderData?.user?.countryCode} ${OrderData?.user?.phoneNo}` || "", // Assuming 'phone' exists for vendor-owner,
        email: OrderData?.user?.email,
      });
    }
  }, []);

  useEffect(() => {
    // if (user === "employee" && role === "Permanent Secretary") {
    //   return;
    // }

    TotalAmount = 0;
    TotalDiscount = 0;
    TotalNetAmount = 0;
    TotalTaxAmount = 0;
    TotalDelivery = 0;
    totalSubTotal = 0;
    let shipped = 0;

    const api =
      user === "vendor-owner" ? "vendor-get-details" : "buyer-get-details";
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/v1/inv-order/${OrderData?.id}/${api}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((data) => {
        const orderdata = data?.data;
        setQuotationData(orderdata);
        setData(data?.data);

        setAlteredPrices(orderdata?.invAlteredPrices);

        if (
          OrderData?.finalStatus === "shipped" ||
          OrderData?.finalStatus === "partially-shipped" ||
          OrderData?.finalStatus === "partially-delivered" ||
          OrderData?.finalStatus === "delivered"
        ) {
          const shippedOrderData = orderdata?.invOrderStatuses?.find(
            (item) =>
              item?.status === "shipped" || item?.status === "partially-shipped"
          );

          setCourierName(shippedOrderData?.courierName);
          setCourierReceiptNo(shippedOrderData?.courierReceiptNo);
        }

        if (
          OrderData?.finalStatus === "delivered" ||
          OrderData?.finalStatus === "partially-delivered"
        ) {
          const deliveredOrderData = orderdata?.invOrderStatuses?.find(
            (item) =>
              item?.status === "delivered" ||
              item?.status === "partially-delivered"
          );
          setCourierReceiptImg(deliveredOrderData?.courierReceiptImg);
          setImageURL(deliveredOrderData?.courierReceiptImg);
          setDeliveryDate(deliveredOrderData?.deliveryDate);
        }

        setProfileData({
          logo:
            user === "vendor-owner"
              ? `${OrderData?.user?.person?.image || ""} `
              : orderdata?.vendorBranch?.logo ||
                orderdata?.vendorCompany?.logo ||
                "",

          name:
            user === "vendor-owner"
              ? `${OrderData?.user?.person?.firstName || ""} ${
                  OrderData?.user?.person?.lastName || ""
                }`.trim()
              : orderdata?.vendorBranch?.name ||
                orderdata?.vendorCompany?.name ||
                "",

          phone:
            user === "vendor-owner"
              ? `${OrderData?.user?.countryCode} ${OrderData?.user?.phoneNo}` ||
                "" // Assuming 'phone' exists for vendor-owner
              : orderdata?.vendorBranch?.primaryPhone || "",

          email:
            user === "vendor-owner"
              ? OrderData?.user?.email || "" // Assuming 'email' exists for vendor-owner
              : orderdata?.vendorBranch?.primaryEmail || "",
        });

        setPlaceOrderProfileData({
          logo: `${orderdata?.buyerUser?.person?.image || ""} `,
          name: `${orderdata?.buyerUser?.person?.firstName || ""} ${
            orderdata?.buyerUser?.person?.lastName || ""
          }`.trim(),
          phone:
            `${orderdata?.buyerUser?.countryCode} ${orderdata?.buyerUser?.phoneNo}` ||
            "", // Assuming 'phone' exists for vendor-owner,
          email: orderdata?.buyerUser?.email,
        });

        setAddress({
          address: orderdata?.mhsssFacility?.address || "",
          city: orderdata?.mhsssFacility?.city || "",
          regionName: orderdata?.mhsssFacility?.regionName || "",
          regionNo: orderdata?.mhsssFacility?.regionNo || "",
          ward: orderdata?.mhsssFacility?.ward || "",
          lot: orderdata?.mhsssFacility?.lot || "",
          type: orderdata?.mhsssFacility?.type || "",
          name: orderdata?.mhsssFacility?.name || "",
        });

        const result =
          orderdata?.invOrderItems?.map((item) => ({
            id: item?.invproductId,
            quantity: item?.actualUnits,
            deliveredUnit:
              item?.invorderitemstatuses?.find((status) => status?.isCurrent)
                ?.partialQtyDelivered || 0,
            status: item?.status,
            totalAmount: item?.totalAmount,
            taxes: item?.taxApplied,
            delivery: item?.calcDeliveryFee,
            discount: item?.discountApplied,
          })) || [];

        setInventoryItems(result);
        // updateCart(result)

        // const updatedCart = fetchCartWithDetails(result, token);
        // setInventoryItems(updatedCart);

        orderdata?.invOrderItems?.forEach((item) => {
          TotalAmount += Number(item?.totalAmount || 0);
          TotalDiscount += Number(item?.discountApplied || 0);
          TotalNetAmount += Number(item?.netAmount || 0);
          TotalTaxAmount += Number(item?.taxApplied || 0);
          TotalDelivery += Number(item?.calcDeliveryFee || 0);

          const getMatchedRate = orderdata?.invAlteredPrices?.find((rate) => {
            if (item?.invadvancepriceId) {
              return rate?.invadvancepriceId === item?.invadvancepriceId;
            }
            return rate?.invproductId === item?.invproductId;
          });

          // Determine the applicable price
          const unitPrice = getMatchedRate?.newPrice
            ? getMatchedRate.newPrice
            : item?.invadvanceprice
            ? item?.invadvanceprice?.price
            : Number(item?.prodBasePrice || 0);

          // Calculate SubTotal
          const SubTotal = Number(item?.actualUnits || 0) * unitPrice;

          totalSubTotal += SubTotal; // Add to the running total
        });

        let PaidAmount = 0;  // Changed 'const' to 'let'

        // Getting total paid Amount
        orderdata?.invOrderPayments?.forEach((item) => {
          PaidAmount += Number(item?.paidAmount || 0);
        });
        
        setPaidAmount(PaidAmount);  // Update state with the new value
        
      })
      .catch(() => {});
  }, [refetch]);

  //   // Function to fetch the unit price for a single product
  //   const fetchUnitPrice = async (invProductId, quantity) => {
  //     try {
  //       const headers = {
  //         Authorization: `Bearer ${token}`,
  //       };

  //       const response = await axios.get(
  //         `${process.env.REACT_APP_BASE_URL}/v1/inv-order/overall-prod-items-calc-by-buyer`,
  //         {
  //           params: {
  //             invProductId,
  //             units: quantity,
  //             program: OrderData.buyerProgram,
  //           },
  //           headers,
  //         }
  //       );

  //       // Extract price and other details from the response
  //       const price = response?.data?.invAdvancePrice?.price || 0;
  //       const type = response?.data?.invAdvancePrice?.type || "";
  //       const taxes = response?.data?.taxDetails?.totalTax || 0;
  //       const discounts = response?.data?.discountDetails?.totalDiscount || 0;
  //       const delivery = response?.data?.deliveryFee?.totalCalcDeliveryFee || 0;
  //       const productTaxDetails =
  //         response?.data?.taxDetails?.productTaxDetails || [];

  //       return { price, type, taxes, discounts, delivery, productTaxDetails };
  //     } catch (error) {
  //       console.error("Error fetching unit price:", invProductId, error);
  //       return { price: 0, type: "", productTaxDetails: [] }; // Default values
  //     }
  //   };

  //   // Function to fetch taxes and discounts for a single product, including unit price
  //   const fetchProductDetails = async (item, token) => {
  //     try {
  //       const {
  //         price: unitPrice,
  //         type,
  //         taxes,
  //         discounts,
  //         delivery,
  //         productTaxDetails,
  //       } = await fetchUnitPrice(item?.id, item?.deliveredUnit, token);

  //       // Calculate total amount for the product
  //       const calculateTotal = (item, priceToUse) => {
  //         const total =
  //           priceToUse * item?.quantity + taxes - discounts + delivery;
  //         return total > 0 ? total?.toFixed(2) : 0; // Ensure no negative totals
  //       };

  //       const total = 0;
  //         item?.type === "basePrice"
  //           ? calculateTotal(item, unitPrice)
  //           : calculateTotal(item, unitPrice);

  //       return {
  //         ...item,
  //         unitPrice,
  //         taxes,
  //         type,
  //         discount: discounts,
  //         total,
  //         delivery,
  //         productTaxDetails,
  //       };
  //     } catch (error) {
  //       console.error("Error fetching product details:", item?.id, error);
  //       return item; // Return item unchanged if there's an error
  //     }
  //   };

  //   // Function to update the entire cart with unit price, taxes, and discounts
  // const fetchCartWithDetails = async (cartItems, token) => {
  //   try {
  //     const updatedCartItems = await Promise.all(
  //       cartItems?.map(async (item) => {
  //         // Process only if status is "partially-shipped" or "partially-delivered"
  //         if (item.status === "partially-shipped" || item.status === "partially-delivered") {
  //           return await fetchProductDetails(item, token);
  //         }
  //         return item; // Keep the item unchanged
  //       })
  //     );
  //     return updatedCartItems;
  //   } catch (error) {
  //     console.error("Error updating cart items with details:", error);
  //     return cartItems; // Return original cart if something goes wrong
  //   }
  // };

  //     const updateCart = async (results) => {
  //       const updatedCart = await fetchCartWithDetails(results, token);

  //       setInventoryItems(updatedCart);
  //       // aggregateTaxes(updatedCart);
  //     };

  const formatName = (data) => {
    return data
      ?.replace(/-/g, " ") // Replace hyphens with spaces
      ?.replace(/\b\w/g, (char) => char?.toUpperCase()); // Capitalize first letter after space or hyphen
  };
  const orderDetails = [
    {
      label: "Purchase Order Number",
      value: `${
        data?.invOrder?.purchasedNo ? data?.invOrder?.purchasedNo : "----"
      }`,
    },
    {
      label: "Order Date & Time",
      value: `${moment(
        QuotationFlow ? OrderData?.quotationDate : OrderData?.orderDate
      ).format("MM/DD/YYYY hh:mm A")}`,
    },
    {
      label: "Delivery Required On",
      value: `${ OrderData?.deliveryRequiredOn ? moment(
       OrderData?.deliveryRequiredOn 
      ).format("MM/DD/YYYY") :"------"}`,
    },

    {
      label: "Total Items",
      value: `${data ? data?.invOrderItems?.length : 0}`,
    },
    { label: "Sub Total", value: `$${totalSubTotal}` },
    { label: "Shipping", value: `$${TotalDelivery}` },
    { label: "Discount", value: `-$${TotalDiscount}` },
    // { label: "Advance Received", value: "0" },
    { label: "Taxes", value: `$${TotalTaxAmount}` },
    { label: "Order Total Amount", value: `$${TotalAmount}` },
    {
      label: "Delivery Required On",
      value: `${
        data?.invOrder?.deliveryRequiredOn
          ? moment(data?.invOrder?.deliveryRequiredOn).format("MM/DD/YYYY")
          : "----"
      }`,
    }, // Placeholder
    {
      label: "Payment Terms",
      value: (
        <div className="flex flex-col">
          <h3 className="text-gray-800 font-semibold capitalize text-[1rem]">
            {data?.invPaymentTerm?.method
              ? formatName(data?.invPaymentTerm?.method)
              : "------"}
          </h3>
          <div className=" text-gray-700">
            <span
              className={`${
                data?.invPaymentTerm?.downPayPercent ? "" : "hidden"
              }`}
            >
              Down Payment- {data?.invPaymentTerm?.downPayPercent}%{" "}
            </span>
            <span
              className={`${data?.invPaymentTerm?.netDays ? "" : "hidden"}`}
            >
              Credit duration- {data?.invPaymentTerm?.netDays} Days
            </span>
          </div>
        </div>
      ),
    },
    {
      label: "Payment Method",
      value: data?.invOrderPayments?.[0]?.method
        ? data?.invOrderPayments?.[0]?.method
        : "-----",
    },
  ];

  const paymentDetails = [
    {
      label: "Status",
      value: `${
        data?.invOrderPayments?.[0]
          ? data?.invOrderPayments?.[0]?.status
          : "----"
      }`,
    },

    {
      label: "Type",
      value: `${
        data?.invOrderPayments?.[0] ? data?.invOrderPayments?.[0]?.type : "----"
      }`,
    },
    {
      label: "Paid Amount",
      value: `${paidAmount ? `$${paidAmount}` : "----"}`,
    },
    {
      label: "Amount Due",
      value: `$${TotalAmount - paidAmount}`,
    },
  ];

  const changeStatus = (status, id) => {
    const api =
      user === "vendor-owner" && QuotationFlow
        ? `v1/inv-order/${OrderData?.id}/vendor-review-quotation`
        : user === "vendor-owner"
        ? "vendor-change-status"
        : user === "employee" && role === "Permanent Secretary"
        ? "ps-change-status"
        : "buyer-change-status";

    const body = {
      finalStatus: status,
    };

    if (status === "shipped") {
      if (courierName === null) {
        setErr("Please select a courier");
        setErrorModal(true);
        return;
      }
      if (courierReceiptNo === "") {
        setErr("Please enter a receipt number");
        setErrorModal(true);
        return;
      }
      body.courierName = courierName;
      body.courierReceiptNo = courierReceiptNo;
    }

    if (status === "delivered") {
      if (courierReceiptImg === null) {
        setErr("Please upload a receipt image");
        setErrorModal(true);
        return;
      }

      if (deliveryDate === null) {
        setErr("Please select delivery date");
        setErrorModal(true);
        return;
      }

      body.courierReceiptImg = courierReceiptImg;
      body.deliveryDate = deliveryDate;
    }

    // if (status === "recieved" ) {
    //   if (receivingDate === null) {
    //     setErr("Please select receiving date");
    //     setErrorModal(true);
    //     return;
    //   }

    //   body.receivingDate = receivingDate;
    // }

    if (status === "ps-rejected") {
      if (note === "") {
        setErr("Please enter a reason for rejection");
        setErrorModal(true);
        return;
      }
      body.reason = note;
    }

    if (status === "cancelled" || status === "buyer-partial-accepted") {
      const orderedItems = quotationData?.invOrderItems.map((item) => {
        return {
          invorderitemId: item?.id,
          status:
            status === "cancelled" ? "cancelled" : "buyer-partial-accepted",
        };
      });

      body.orderItems = orderedItems; // Ensure orderItems is always sent
    }

    if (OrderData?.finalStatus === "delivered") {
      const orderedItems = quotationData?.invOrderItems.map((item) => {
        return {
          invorderitemId: item?.id,
          status: "recieved",
        };
      });

      body.orderItems = orderedItems; // Ensure orderItems is always sent
      body.finalStatus = "recieved";
    }

    if (OrderData?.finalStatus === "partially-delivered") {
      const orderedItems = quotationData?.invOrderItems.map((item) => {
        const currentStatus = item?.invorderitemstatuses?.find(
          (status) => status?.isCurrent
        );
        const itemStatus = !currentStatus?.partialQtyDelivered
          ? "recieved"
          : "partially-recieved";

        const orderItem = {
          invorderitemId: item?.id,
          status: itemStatus,
        };

        return orderItem;
      });

      body.orderItems = orderedItems; // Ensure orderItems is always sent

      // Check if any order item has 'partially-in-progress' status
      const hasPartialProgress = orderedItems.some(
        (item) => item.status === "partially-recieved"
      );

      body.finalStatus = hasPartialProgress ? "partially-recieved" : "recieved";
    }

    if (user === "vendor-owner" && !QuotationFlow) {
      if (OrderData?.finalStatus === "submitted") {
        const orderedItems = quotationData?.invOrderItems.map((item) => {
          const itemStatus =
            !item?.partialQuantity ||
            item?.actualUnits === item?.partialQuantity
              ? "in-progress"
              : "partially-in-progress";

          return {
            invorderitemId: item?.id,
            status: itemStatus,
            ...(item?.partialQuantity &&
            item?.actualUnits !== item?.partialQuantity
              ? { partialQtyDelivered: item.partialQuantity }
              : {}),
          };
        });

        body.orderItems = orderedItems; // Ensure orderItems is always sent

        // Check if any order item has 'partially-in-progress' status
        const hasPartialProgress = orderedItems.some(
          (item) => item.status === "partially-in-progress"
        );

        body.finalStatus = hasPartialProgress
          ? "partially-in-progress"
          : "in-progress";
      }

      if (
        OrderData?.finalStatus === "in-progress" ||
        OrderData?.finalStatus === "buyer-partial-accepted"
      ) {
        const orderedItems = quotationData?.invOrderItems.map((item) => {
          const currentStatus = item?.invorderitemstatuses?.find(
            (status) => status?.isCurrent
          );
          const itemStatus = !currentStatus?.partialQtyDelivered
            ? "shipped"
            : "partially-shipped";

          const orderItem = {
            invorderitemId: item?.id,
            status: itemStatus,
          };

          // Only include partialQtyDelivered if it has a valid value (not null or undefined)
          if (currentStatus?.partialQtyDelivered != null) {
            orderItem.partialQtyDelivered = currentStatus.partialQtyDelivered;
          }

          return orderItem;

          // const itemStatus =

          //    item?.actualUnits !== currentStatus?.partialQtyDelivered
          //         ? "partially-shipped"
          //         : "shipped";

          // return {
          //     invorderitemId: item?.id,
          //     status: itemStatus,
          //     ...(item?.actualUnits === currentStatus?.partialQtyDelivered
          //         ? { partialQtyDelivered: currentStatus?.partialQtyDelivered }
          //         : {}),
          // };
        });

        body.orderItems = orderedItems; // Ensure orderItems is always sent

        // Check if any order item has 'partially-in-progress' status
        const hasPartialProgress = orderedItems.some(
          (item) => item.status === "partially-shipped"
        );

        body.finalStatus = hasPartialProgress ? "partially-shipped" : "shipped";
      }

      // if (
      //   OrderData?.finalStatus === "shipped" ||
      //   OrderData?.finalStatus === "partially-shipped"
      // ) {
      //   const orderedItems = quotationData?.invOrderItems.map((item) => {
      //     const currentStatus = item?.invorderitemstatuses?.find(
      //       (status) => status?.isCurrent
      //     );
      //     console.log(currentStatus);
      //     const itemStatus = !currentStatus?.partialQtyDelivered
      //       ? "delivered"
      //       : "partially-delivered";

      //     const orderItem = {
      //       invorderitemId: item?.id,
      //       status: itemStatus,
      //     };

      //     // Only include partialQtyDelivered if it has a valid value (not null or undefined)
      //     if (currentStatus?.partialQtyDelivered != null) {
      //       orderItem.partialQtyDelivered = currentStatus.partialQtyDelivered;
      //     }

      //     return orderItem;

      //     // const itemStatus =

      //     //    item?.actualUnits !== currentStatus?.partialQtyDelivered
      //     //         ? "partially-shipped"
      //     //         : "shipped";

      //     // return {
      //     //     invorderitemId: item?.id,
      //     //     status: itemStatus,
      //     //     ...(item?.actualUnits === currentStatus?.partialQtyDelivered
      //     //         ? { partialQtyDelivered: currentStatus?.partialQtyDelivered }
      //     //         : {}),
      //     // };
      //   });

      //   body.orderItems = orderedItems; // Ensure orderItems is always sent

      //   // Check if any order item has 'partially-in-progress' status
      //   const hasPartialProgress = orderedItems.some(
      //     (item) => item.status === "partially-delivered"
      //   );

      //   body.finalStatus = hasPartialProgress
      //     ? "partially-delivered"
      //     : "delivered";
      // }

      // if (
      //   OrderData?.finalStatus === "shipped" ||
      //   OrderData?.finalStatus === "partially-shipped"
      // ) {
      //   const orderedItems = quotationData?.invOrderItems
      //     ?.filter((item) => item?.status !== "recieved") // Exclude already received items
      //     .map((item) => {
      //       const currentStatus = item?.invorderitemstatuses?.find(
      //         (status) => status?.isCurrent
      //       );

      //       console.log("Current Status:", currentStatus);

      //       // Extract necessary values
      //       const actualUnits = item?.actualUnits || 0;
      //       const partialQtyDelivered = currentStatus?.partialQtyDelivered || 0;
      //       const pendingQuantity = actualUnits - partialQtyDelivered;

      //       console.log("Calculated Quantities:", {
      //         actualUnits,
      //         partialQtyDelivered,
      //         pendingQuantity,
      //       });

      //       // Determine item status based on pending quantity
      //       let itemStatus = "delivered";
      //       if (pendingQuantity > 0 && partialQtyDelivered > 0) {
      //         itemStatus = "partially-delivered";
      //       }

      //       // Construct the order item object
      //       const orderItem = {
      //         invorderitemId: item?.id,
      //         status: itemStatus,
      //       };

      //       // Include partialQtyDelivered only if it's relevant
      //       if (partialQtyDelivered > 0) {
      //         orderItem.partialQtyDelivered = partialQtyDelivered;
      //       }

      //       return { ...orderItem, pendingQuantity };
      //     });

      //   body.orderItems = orderedItems; // Ensure orderItems is always sent

      //   // Check if any order item has 'partially-delivered' status
      //   const hasPartialProgress = orderedItems.some(
      //     (item) => item.status === "partially-delivered"
      //   );

      //   // Check final status based on enteredPartialQuantity and pendingQuantity
      //   const allFullyDelivered = orderedItems.every(
      //     (item) => item.partialQtyDelivered === item.pendingQuantity
      //   );
      //   const filteredBodyItems = orderedItems?.map((item) => {
      //     const { invorderitemId, status, partialQtyDelivered } = item;

      //     return {
      //       invorderitemId,
      //       status,
      //       ...(partialQtyDelivered !== undefined && { partialQtyDelivered })
      //     };
      //   });

      //   body.orderItems = filteredBodyItems;
      //   // body.finalStatus = allFullyShipped ? "shipped" : "partially-shipped";

      //   body.finalStatus = allFullyDelivered
      //     ? "delivered"
      //     : hasPartialProgress
      //     ? "partially-delivered"
      //     : "delivered"; // Fallback to delivered if no partials exist
      // }

      if (
        OrderData?.finalStatus === "shipped" ||
        OrderData?.finalStatus === "partially-shipped"
      ) {
        const orderedItems = quotationData?.invOrderItems
          ?.filter((item) => item?.status !== "recieved") // Exclude already received items
          ?.map((item) => {
            // Find the latest partially-delivered status
            const latestPartiallyDeliveredStatus = item?.invorderitemstatuses
              ?.filter((status) => status?.status === "partially-recieved")
              ?.reduce(
                (latest, status) =>
                  new Date(status.updatedAt) > new Date(latest.updatedAt)
                    ? status
                    : latest,
                { updatedAt: new Date(0), partialQtyDelivered: 0 } // Default to avoid undefined
              );

            const currentStatus = item?.invorderitemstatuses?.find(
              (status) => status?.isCurrent
            );

            // Extract necessary values
            const actualUnits = item?.actualUnits || 0;
            const partialQtyDelivered = currentStatus?.partialQtyDelivered || 0;
            const alreadyDelivered =
              latestPartiallyDeliveredStatus?.partialQtyDelivered || 0;
            const totalProcessed = alreadyDelivered + partialQtyDelivered;
            const pendingQuantity = actualUnits - partialQtyDelivered;

            // Determine item status based on pending quantity
            let itemStatus = "delivered";
            if (pendingQuantity > 0 && partialQtyDelivered > 0) {
              itemStatus = "partially-delivered";
            }

            // Construct the order item object
            return {
              invorderitemId: item?.id,
              status: itemStatus,
              partialQtyDelivered,
              pendingQuantity,
              totalProcessed,
              actualUnits,
            };
          });

        body.orderItems = orderedItems; // Ensure orderItems is always sent

        // Check if any order item has 'partially-delivered' status
        const hasPartialProgress = orderedItems.some(
          (item) => item.status === "partially-delivered"
        );

        // Check if all items are fully delivered
        const allFullyDelivered = orderedItems.every((item) => {
          return item.totalProcessed - item.actualUnits === 0;
        });

        const fulldeliveredStatus = orderedItems.every((item) => {
          return item?.partialQtyDelivered === 0;
        });

        const filteredBodyItems = orderedItems?.map(
          ({ invorderitemId, status, partialQtyDelivered }) => ({
            invorderitemId,
            status,
            ...(partialQtyDelivered !== undefined && partialQtyDelivered !== 0
              ? { partialQtyDelivered }
              : {}),
          })
        );

        body.orderItems = filteredBodyItems;

        // Determine final status
        if (allFullyDelivered || fulldeliveredStatus) {
          body.finalStatus = "delivered";
        } else if (hasPartialProgress) {
          body.finalStatus = "partially-delivered";
        } else {
          body.finalStatus = "partially-shipped"; // Fallback
        }

        // Enhanced console log for final status
      }

      if (OrderData?.finalStatus === "partially-recieved") {
        const orderedItems = quotationData?.invOrderItems
          ?.filter((item) => item?.status !== "recieved") // Ensure proper filtering
          .map((item) => {
            const currentStatus = item?.invorderitemstatuses?.find(
              (status) => status?.isCurrent
            );

            // Calculate the quantities
            const actualUnits = item?.actualUnits || 0;
            const enteredPartialQuantity = item?.partialQuantity || 0;
            const partialQtyDelivered = currentStatus?.partialQtyDelivered || 0;
            const pendingQuantity = actualUnits - partialQtyDelivered;

            // Check if the item is fully shipped
            const itemStatus =
              pendingQuantity === 0 ? "shipped" : "partially-shipped";

            const orderItem = {
              invorderitemId: item?.id,
              status: itemStatus,
              enteredPartialQuantity, // Include enteredPartialQuantity
              pendingQuantity, // Include pendingQuantity
            };

            // Include partialQtyDelivered if valid
            if (partialQtyDelivered > 0) {
              orderItem.partialQtyDelivered = pendingQuantity;
            }

            return orderItem; // Return orderItem directly
          });

        // Check final status based on enteredPartialQuantity and pendingQuantity
        const allFullyShipped = orderedItems.every(
          (item) =>
            item.enteredPartialQuantity === item.pendingQuantity &&
            item.pendingQuantity === 0
        );

        // body.orderItems = orderedItems;

        const filteredBodyItems = orderedItems?.map((item) => {
          const { invorderitemId, status, pendingQuantity } = item;

          return {
            invorderitemId,
            status,
            ...(pendingQuantity !== undefined && {
              partialQtyDelivered: pendingQuantity,
            }),
          };
        });

        body.orderItems = filteredBodyItems;
        body.finalStatus = "shipped";

        // body.finalStatus = allFullyShipped ? "shipped" : "partially-shipped";
      }
    }

    // return;
    axios
      .patch(
        `${process.env.REACT_APP_BASE_URL}/v1/inv-order/${OrderData?.id}/${api}`,
        body,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        if (changeStatus === "ps-rejected") {
          setShowRejectModal(false);
        }

        if (response?.data?.invOrder?.finalStatus === "recieved") {
          setShowFeedback(true);
          return;
        }
        router("/Inventory-Vendor-Orders");
      })
      .catch((err) => {
        setErr(err?.response?.data?.message);
        setErrorModal(true);
      });
  };

  // const changeStatus = (status, id) => {
  //   const api =
  //     user === "vendor-owner" && QuotationFlow
  //       ? `v1/inv-order/${OrderData?.id}/vendor-review-quotation`
  //       : user === "vendor-owner"
  //       ? "vendor-change-status"
  //       : user === "employee" && role === "Permanent Secretary"
  //       ? "ps-change-status"
  //       : "buyer-change-status";

  //   const body = {
  //     finalStatus: status,
  //   };

  //   if (status === "shipped") {
  //     if (courierName === null) {
  //       setErr("Please select a courier");
  //       setErrorModal(true);
  //       return;
  //     }
  //     if (courierReceiptNo === "") {
  //       setErr("Please enter a receipt number");
  //       setErrorModal(true);
  //       return;
  //     }
  //     body.courierName = courierName;
  //     body.courierReceiptNo = courierReceiptNo;
  //   }

  //   if (status === "delivered") {
  //     if (courierReceiptImg === null) {
  //       setErr("Please upload a receipt image");
  //       setErrorModal(true);
  //       return;
  //     }

  //     if (deliveryDate === null) {
  //       setErr("Please select delivery date");
  //       setErrorModal(true);
  //       return;
  //     }

  //     body.courierReceiptImg = courierReceiptImg;
  //     body.deliveryDate = deliveryDate;
  //   }

  //   if (status === "recieved") {
  //     if (receivingDate === null) {
  //       setErr("Please select receiving date");
  //       setErrorModal(true);
  //       return;
  //     }

  //     body.receivingDate = receivingDate;
  //   }

  //   if (status === "ps-rejected") {
  //     if (note === "") {
  //       setErr("Please enter a reason for rejection");
  //       setErrorModal(true);
  //       return;
  //     }
  //     body.reason = note;
  //   }

  //   const result =
  //   quotationData?.invOrderItems?.map((item) => ({
  //     id: item?.id,
  //     actualUnits: item?.actualUnits,
  //     deliveredUnit:
  //       item?.invorderitemstatuses?.find((status) => status?.isCurrent)
  //         ?.partialQtyDelivered || null,
  //     status: item?.status,
  //     partialQuantity:item?.partialQuantity
  //   })) || [];

  //   console.log(result)

  //   if (
  //     user === "vendor-owner" &&
  //     !QuotationFlow &&
  //     quotationData?.invOrderItems?.length &&
  //     quotationData.invOrderItems.some((item) => item.partialQuantity) // Check if any item has partialQuantity present
  //   ) {
  //     const orderedItems = quotationData?.invOrderItems.map((item) => {
  //       return {
  //         invorderitemId: item?.id,
  //         status:
  //           !item?.partialQuantity ||
  //           item?.actualUnits === item?.partialQuantity
  //             ? "delivered"
  //             : OrderData?.finalStatus === "submitted"
  //             ? "partially-in-progress"
  //             : OrderData?.finalStatus === "partially-in-progress"
  //             ? "partially-shipped"
  //             : "partially-delivered",
  //         ...(item?.partialQuantity &&
  //         item?.actualUnits !== item?.partialQuantity
  //           ? { partialQtyDelivered: item.partialQuantity }
  //           : {}),
  //       };
  //     });

  //     body.orderItems = orderedItems;
  //     body.finalStatus =
  //       OrderData?.finalStatus === "submitted"
  //         ? "partially-in-progress"
  //         : "partially-shipped";
  //   }

  //   if (
  //     user === "vendor-owner" &&
  //     OrderData?.finalStatus === "partially-shipped"
  //   ) {
  //     const orderedItems = quotationData?.invOrderItems.map((item) => {
  //       // Find the current item status only once
  //       const currentStatus = item?.invorderitemstatuses?.find(
  //         (status) => status?.isCurrent
  //       );

  //       // Determine the status based on the current status
  //       const status =
  //         currentStatus?.status === "partially-shipped"
  //           ? "partially-delivered"
  //           : item?.status;

  //       // Build the result object, adding partialQtyDelivered if available
  //       const result = {
  //         invorderitemId: item?.id,
  //         status,
  //       };

  //       // Add partialQtyDelivered if it exists
  //       if (currentStatus?.partialQtyDelivered) {
  //         result.partialQtyDelivered = currentStatus.partialQtyDelivered;
  //       }

  //       return result;
  //     });

  //     body.finalStatus = "partially-delivered";
  //     body.orderItems = orderedItems;
  //   }

  //   return;
  //   axios
  //     .patch(
  //       `${process.env.REACT_APP_BASE_URL}/v1/inv-order/${OrderData?.id}/${api}`,
  //       body,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     )
  //     .then(() => {
  //       if (changeStatus === "ps-rejected") {
  //         setShowRejectModal(false);
  //       }

  //       if (status === "recieved") {
  //         setShowFeedback(true);
  //         return;
  //       }
  //       router("/Inventory-Vendor-Orders");
  //     })
  //     .catch((err) => {
  //       setErr(err?.response?.data?.message);
  //       setErrorModal(true);
  //     });
  // };

  const changeQuotationStatus = (status) => {
    const api = `v1/inv-order/${OrderData?.id}/vendor-review-quotation`;

    const body = {
      finalStatus: status,
    };

    if (status === "vendor-accepted-quot") {
      const items = quotationData?.invOrderItems?.map((item) => ({
        id: item.id, // Extract the item's id
        alteredPrice: item?.revisedRate || item?.prodBasePrice, // You can decide which price to use here, for example, revisedRate or basePrice
      }));

      // You can now use the 'items' array as needed
      body.alteredOrderItems = items;
    }

    axios
      .post(`${process.env.REACT_APP_BASE_URL}/${api}`, body, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        if (changeStatus === "ps-rejected") {
          setShowRejectModal(false);
        }
        router("/Inventory/Quotations");
      })
      .catch((err) => {
        setErr(err?.response?.data?.message);
        setErrorModal(true);
      });
  };

  //Upload Receipt Image
  const imageHandler = (setState, setUrl) => async (e) => {
    file = e.target.files[0];
    const base641 = await convertToBase64(file);
    var bodyFormData = new FormData();
    bodyFormData.append("file", file);
    axios({
      method: "post",
      url: `${process.env.REACT_APP_BASE_URL}/v1/file/vendor/images?fileType=courierReceipt`,
      data: bodyFormData,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((data) => {
        setUrl(data?.data?.url);
        setState(base641);
      })
      .catch(() => {});
  };

  function convertToBase64(file) {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  }
  // const getButtonClass = () => {
  //   if (user === "vendor-owner") {
  //     if (QuotationFlow && OrderData?.finalStatus !== "quotation") {
  //       return "hidden";
  //     }
  //     if (!QuotationFlow && OrderData?.finalStatus !== "submitted") {
  //       return "hidden";
  //     }
  //   }

  //   if (user === "employee" && role !== "Permanent Secretary") {
  //     return "hidden";
  //   }

  //   if (
  //     user === "employee" &&
  //     role === "Permanent Secretary" &&
  //     data?.invOrder?.finalStatus !== "awaited-ps"
  //   ) {
  //     return "hidden";
  //   }

  //   if (buyerUserId === data?.buyerUser?.id) {
  //     return "hidden";
  //   }

  //   return user === "employee" &&
  //     role === "Permanent Secretary" &&
  //     data?.invOrder?.finalStatus === "awaited-ps"
  //     ? "px-6 py-2 bg-primary text-white rounded-md w-[17rem]"
  //     : "px-6 py-2 bg-primary text-white rounded-md w-[14rem]";
  // };

  const getButtonClass = () => {
    // If the user is a vendor-owner, return the button class only for specific cases
    if (user === "vendor-owner") {
      if (
        (QuotationFlow && OrderData?.finalStatus === "quotation") ||
        (!QuotationFlow && OrderData?.finalStatus === "submitted")
      ) {
        return "px-6 py-2 bg-primary text-white rounded-md w-[14rem]";
      }
      return "hidden";
    }

    // If the user is an employee but not a Permanent Secretary, always hide
    if (user === "employee" && role !== "Permanent Secretary") {
      return "hidden";
    }

    // If the user is an employee and a Permanent Secretary, check order status
    if (user === "employee" && role === "Permanent Secretary") {
      return data?.invOrder?.finalStatus === "awaited-ps"
        ? "px-6 py-2 bg-primary text-white rounded-md w-[17rem]"
        : "hidden";
    }

    // If the buyerUserId matches the current user, always hide
    if (buyerUserId === data?.buyerUser?.id) {
      return "hidden";
    }

    // Default case: Hide the button
    return "hidden";
  };

  const getButtonClassRed = () => {
    // If the user is a vendor-owner, return the button class only for specific cases
    if (user === "vendor-owner") {
      if (
        (QuotationFlow && OrderData?.finalStatus === "quotation") ||
        (!QuotationFlow && OrderData?.finalStatus === "submitted")
      ) {
        return "px-6 py-2 bg-red-600 text-white rounded-md w-[14rem]";
      }
      return "hidden";
    }

    // If the user is an employee and a Permanent Secretary, check order status
    if (user === "employee" && role === "Permanent Secretary") {
      return data?.invOrder?.finalStatus === "awaited-ps"
        ? "px-6 py-2 bg-red-600 text-white rounded-md w-[17rem]"
        : "hidden";
    }

    // If the buyerUserId matches the current user, always hide
    if (
      buyerUserId === data?.buyerUser?.id &&
      OrderData?.finalStatus !== "submitted"
    ) {
      return "hidden";
    }

    // Default case: Hide the button
    return "hidden";
  };

  const getButtonClassRed2 = () => {
    if (
      user === "vendor-owner" &&
      QuotationFlow &&
      OrderData?.finalStatus !== "quotation"
    ) {
      return "hidden";
    }
    if (
      user === "vendor-owner" &&
      OrderData?.finalStatus !== "submitted" &&
      !QuotationFlow
    ) {
      return "hidden";
    }

    if (
      user === "employee" &&
      role === "Permanent Secretary" &&
      data?.invOrder?.finalStatus !== "awaited-ps"
    ) {
      return "hidden";
    }

    if (
      buyerUserId === data?.buyerUser?.id &&
      OrderData?.finalStatus !== "submitted"
    ) {
      return "hidden";
    }

    return user === "employee" &&
      role === "Permanent Secretary" &&
      data?.invOrder?.finalStatus === "awaited-ps"
      ? "px-6 py-2 bg-red-600 text-white rounded-md w-[14rem]"
      : "px-6 py-2 bg-red-600 text-white rounded-md w-[14rem]";
  };

  const statusStyles = {
    "awaited-ps": {
      bg: "bg-gray-100",
      text: "text-gray-800",
      label: "Awaited PS",
    },
    "ps-rejected": {
      bg: "bg-red-100",
      text: "text-red-800",
      label: "PS Rejected",
    },
    "ps-approved": {
      bg: "bg-green-100",
      text: "text-green-800",
      label: "PS Approved",
    },
    submitted: {
      bg: "bg-blue-200",
      text: "text-blue-700",
      label: "Order Submitted",
    },
    "re-submitted": {
      bg: "bg-blue-200",
      text: "text-blue-700",
      label: "Re-Submitted",
    },
    "in-progress": {
      bg: "bg-yellow-100",
      text: "text-[#e0aa36]",
      label: "In Progress",
    },
    partial: {
      bg: "bg-orange-100",
      text: "text-orange-800",
      label: "Partial",
    },
    "partially-in-progress": {
      bg: "bg-yellow-200",
      text: "text-yellow-800",
      label: "Partially In Progress",
    },
    "partially-shipped": {
      bg: "bg-purple-200",
      text: "text-purple-800",
      label: "Partially Shipped",
    },
    shipped: {
      bg: "bg-purple-100",
      text: "text-purple-800",
      label: "Shipped",
    },
    "partially-delivered": {
      bg: "bg-teal-200",
      text: "text-teal-800",
      label: "Partially Delivered",
    },
    delivered: {
      bg: "bg-teal-100",
      text: "text-teal-800",
      label: "Delivered",
    },
    "delivered-issue": {
      bg: "bg-pink-100",
      text: "text-pink-800",
      label: "Delivered Issue",
    },
    recieved: {
      bg: "bg-indigo-100",
      text: "text-indigo-800",
      label: "Received",
    },
    "partially-recieved": {
      bg: "bg-indigo-200",
      text: "text-indigo-800",
      label: "Partially Received",
    },
    cancelled: {
      bg: "bg-red-200",
      text: "text-red-800",
      label: "Cancelled",
    },
    "buyer-partial-accepted": {
      bg: "bg-cyan-200", // Light Cyan for a soft neutral approval
      text: "text-cyan-800", // Dark Cyan for readability
      label: "Partial Order Accepted",
    },
  };

  return (
    <div>
      <div className="mt-3  rounded-md  md:p-[3rem] p-[1rem] pt-[2rem] mb-6  sm:min-h-[360px] bg-[#F6F4F4] shadow-lg">
        <div className="">
          <div
            className={`${
              buyerUserId === data?.buyerUser?.id &&
              OrderData?.finalStatus === "partially-in-progress" &&
              !QuotationFlow
                ? "bg-white p-4  mb-4"
                : "hidden"
            }`}
          >
            <h1 className="text-gray-700 font-semibold text-[0.93rem]">
              The vendor has partially accepted the order and will ship some
              items now while processing the pending items later. Would you like
              to proceed with this order?
            </h1>

            <div className="flex items-center justify-center sm:gap-6 gap-3 mt-4 sm:flex-row flex-col-reverse">
              <button
                className={`${"px-6 py-2 bg-red-600 text-white rounded-md w-[16rem]"}`}
                onClick={() => {
                  changeStatus("cancelled");
                }}
              >
                Cancel
              </button>
              <button
                className={`${"px-6 py-2 bg-primary text-white rounded-md w-[16rem]"}`}
                onClick={() => {
                  changeStatus("buyer-partial-accepted");
                }}
              >
                Accept and Proceed With Order
              </button>
            </div>
          </div>

          <div
            className={`${
              user === "vendor-owner" &&
              OrderData?.finalStatus === "partially-in-progress" &&
              !QuotationFlow
                ? "bg-white p-4  mb-4"
                : "hidden"
            }`}
          >
            <h1 className="text-gray-700 font-semibold text-[0.93rem] text-center">
              We are awaiting the buyer's response to proceed with the
              partial order.
            </h1>
          </div>
          {/* First Div */}
          <div className="flex gap-4 sm:mb-[3rem] mb-[1rem] md:flex-row flex-col">
            <div className="flex-1">
              <h3 className="text-[0.93rem] font-semibold mb-2">
                {user === "vendor-owner" ? "Buyer" : "Vendor"} Details :
              </h3>
              <div className="bg-white p-4 h-full px-5 rounded-sm">
                <div className="bg-[#F3F5F4] flex items-center justify-between w-full p-2 h-full rounded-md sm:px-6 ">
                  {/* Left side - Buyer Image and Info */}
                  <div className="flex items-center sm:space-x-4 space-x-2">
                    <img
                      src={profileData?.logo}
                      alt="Buyer Name"
                      className="sm:w-20 sm:h-20 w-14 h-14 rounded-full"
                    />
                    <div>
                      <h2 className="text-lg  font-bold capitalize">
                        {profileData?.name}
                      </h2>
                      <p className="text-sm text-gray-600">
                        {profileData?.phone}
                      </p>
                      <p className="text-sm text-gray-600">
                        {profileData?.email}
                      </p>
                    </div>
                  </div>

                  {/* Right side - Send Message and Role Info */}
                  <div className="flex items-center space-x-6">
                    <div className="text-right">
                      <div className="flex items-center space-x-2 mb-5">
                        <button className="text-black font-semibold text-[0.9rem]">
                          send message
                        </button>
                        <img src={chatIcon} alt="chat" className="w-5 h-5" />
                      </div>
                      {/* <p className="text-sm text-gray-500 capitalize">{user}</p>
                      <p className="text-sm text-teal-500">Designation</p> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex-1">
              <h3 className="text-[0.93rem] font-semibold mb-2">Shipped at:</h3>
              <div className="bg-white p-4 h-full px-5 rounded-sm">
                <div className="bg-[#F3F5F4] flex w-full p-4 h-full rounded px-6 flex-col">
                  <h2 className="font-semibold text-lg">
                    {address?.name + " " + address?.type}
                  </h2>
                  <p className="text-sm">
                    {[
                      address?.lot,
                      address?.address,
                      address?.regionNo, // Add "Region" prefix only if regionNo exists
                      address?.regionName,
                      address?.city,
                      address?.ward,
                    ]
                      .filter(Boolean) // Remove any falsy values (null, undefined, empty string, etc.)
                      .join(", ")}{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* <div
            className={`${
              buyerUserId === data?.buyerUser?.id &&
              OrderData?.finalStatus === "partially-in-progress" &&
              !QuotationFlow
                ? "bg-white p-4 mt-4 mb-4"
                : "hidden"
            }`}
          >
            <h1 className="text-gray-700 font-semibold text-[0.93rem]">
              The vendor has partially accepted the order and will ship some
              items now while processing the pending items later. Would you like
              to proceed with this order?
            </h1>

 <div className="flex items-center justify-center gap-6 mt-4">
        <button
          className={`${"px-6 py-2 bg-red-600 text-white rounded-md w-[14rem]"}`}
          onClick={() => {
          }}
        >
          Cancel
        </button>
        <button
          className={`${
           "px-6 py-2 bg-primary text-white rounded-md w-[14rem]"
             
          }`}
          onClick={() => {
          
            // changeStatus();
          }}
          
        >
          Accept and Proceed Order
        </button>
      </div>
          </div> */}

          <div
            className={`${
              (user === "superadmin" ||
                (user === "employee" && role === "Permanent Secretary")) &&
              !QuotationFlow
                ? "flex gap-4 mb-[3rem] "
                : "hidden"
            } `}
          >
            <div className="flex-1 ">
              <h3 className="text-[0.93rem] font-semibold mb-2">
                Order Placed By :
              </h3>
              <div className="bg-white sm:p-4 h-full sm:px-5 rounded-sm p-4 ">
                <div className="bg-[#F3F5F4] flex items-center justify-between w-full p-2 h-full rounded-md sm:px-6 ">
                  {/* Left side - Buyer Image and Info */}
                  <div className="flex items-center sm:space-x-4 space-x-2">
                    <img
                      src={placeOrderProfileData?.logo}
                      alt="Buyer Name"
                      className="sm:w-20 sm:h-20 w-14 h-14 rounded-full"
                    />
                    <div>
                      <h2 className="text-lg font-bold capitalize">
                        {placeOrderProfileData?.name}
                      </h2>
                      <p className="text-sm text-gray-600">
                        {placeOrderProfileData?.phone}
                      </p>
                      <p className="text-sm text-gray-600">
                        {placeOrderProfileData?.email}
                      </p>
                    </div>
                  </div>

                  {/* Right side - Send Message and Role Info */}
                  <div className="flex items-center space-x-6">
                    <div className="text-right">
                      {/* <div className="flex items-center space-x-2 mb-5">
                        <button className="text-black font-semibold text-[0.9rem]">
                          send message
                        </button>
                        <img src={chatIcon} alt="chat" className="w-5 h-5" />
                      </div> */}
                      <p className="text-sm text-gray-500 capitalize">
                        {data?.buyerUser?.roles?.[0]}
                      </p>
                      <p className="text-sm text-teal-500">Designation</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full flex gap-3 sm:flex-row flex-col-reverse">
            <div className=" sm:w-[60%] w-full flex flex-col gap-4">
              <div className="bg-white p-4">
                {/* Buyer Buttons */}
                <div
                  className={`${
                    buyerUserId === data?.buyerUser?.id &&
                    (OrderData?.finalStatus === "delivered" ||
                      OrderData?.finalStatus === "partially-delivered")
                      ? "flex flex-col gap-4 pb-4"
                      : "hidden"
                  }`}
                >
                  <div
                    className={`${
                      OrderData?.finalStatus === "delivered" ||
                      OrderData?.finalStatus === "partially-delivered"
                        ? "flex justify-between"
                        : "hidden"
                    }`}
                  >
                    <h1 className="text-red-600 font-semibold text-[0.95rem]">
                      Update Order Detail
                    </h1>
                    <button
                      className={`${
                        OrderData?.finalStatus === "delivered" ||
                        OrderData?.finalStatus === "partially-delivered"
                          ? "px-6 py-2 bg-primary text-white rounded-md w-[10rem]"
                          : "hidden"
                      }`}
                      onClick={() => {
                        changeStatus("recieved");
                      }}
                    >
                      Mark as Received
                    </button>
                  </div>
                  <div className="grid grid-cols-2 gap-x-3 ">
                    <div
                      className={`${
                        OrderData?.finalStatus === "shipped" ||
                        OrderData?.finalStatus === "delivered" ||
                        OrderData?.finalStatus === "recieved"
                          ? ""
                          : "hidden"
                      }`}
                    >
                      <label className="block text-gray-600 font-medium">
                        Receiving Date
                      </label>
                      <DatePicker
                        value={
                          receivingDate
                            ? dayjs(receivingDate, "YYYY-MM-DD ")
                            : null
                        }
                        onChange={(date) => setReceivingDate(date)}
                        format="MM/DD/YYYY"
                        className={`${
                          OrderData?.finalStatus === "recieved"
                            ? "pointer-events-none  w-full mt-1"
                            : "w-full mt-1"
                        }`}
                        allowClear={false}
                        disabledDate={(current) =>
                          current && current?.isAfter(dayjs().endOf("day"))
                        }
                      />
                    </div>
                  </div>
                </div>

                {/* Vendor Buttons */}
                <div
                  className={`${
                    user === "vendor-owner" &&
                    (OrderData?.finalStatus === "buyer-partial-accepted" ||
                      OrderData?.finalStatus === "shipped" ||
                      OrderData?.finalStatus === "partially-shipped" ||
                      OrderData?.finalStatus === "partially-delivered" ||
                      OrderData?.finalStatus === "delivered" ||
                      OrderData?.finalStatus === "in-progress" ||
                      OrderData?.finalStatus === "partially-recieved")
                      ? "flex flex-col gap-4 pb-4"
                      : "hidden"
                  }`}
                >
                  <div
                    className={`${
                      OrderData?.finalStatus === "delivered" ||
                      OrderData?.finalStatus === "partially-delivered"
                        ? "hidden"
                        : "flex justify-between"
                    }`}
                  >
                    <h1 className="text-red-600 font-semibold sm:text-[0.95rem] text-sm">
                      {OrderData?.finalStatus === "shipped"
                        ? "Update Delivery Detail"
                        : "Update Shipping Detail"}
                    </h1>
                    <button
                      className={`${
                        OrderData?.finalStatus === "delivered" ||
                        OrderData?.finalStatus === "partially-delivered"
                          ? "hidden"
                          : "px-6 py-2 bg-primary text-white rounded-md sm:w-[14rem] w-[11rem]"
                      }`}
                      onClick={() => {
                        OrderData?.finalStatus === "buyer-partial-accepted" ||
                        OrderData?.finalStatus === "in-progress" ||
                        OrderData?.finalStatus === "partially-recieved"
                          ? changeStatus("shipped")
                          : changeStatus("delivered");
                      }}
                    >
                      {OrderData?.finalStatus === "buyer-partial-accepted" ||
                      OrderData?.finalStatus === "in-progress"
                        ? "Mark as Shipped"
                        : OrderData?.finalStatus === "partially-recieved"
                        ? "Process Pending Items"
                        : "Mark as Delivered"}
                    </button>
                  </div>
                  <div className="grid sm:grid-cols-2 sm:gap-x-3 grid-cols-1 sm:gap-0 gap-3">
                    {/* Delivery Date */}
                    <div
                      className={`${
                        OrderData?.finalStatus === "shipped" ||
                        OrderData?.finalStatus === "partially-shipped" ||
                        OrderData?.finalStatus === "partially-delivered" ||
                        OrderData?.finalStatus === "delivered"
                          ? ""
                          : "hidden"
                      }`}
                    >
                      <label className="block text-gray-600 font-medium">
                        Delivery Date
                      </label>
                      <DatePicker
                        value={
                          deliveryDate
                            ? dayjs(deliveryDate, "YYYY-MM-DD ")
                            : null
                        }
                        onChange={(date) => setDeliveryDate(date)}
                        format="MM/DD/YYYY"
                        className={`${
                          OrderData?.finalStatus === "delivered"
                            ? "pointer-events-none  w-full mt-1"
                            : "w-full mt-1"
                        }`}
                        // suffixIcon={<CalendarOutlined />}
                        allowClear={false}
                        disabledDate={(current) =>
                          current && current?.isAfter(dayjs().endOf("day"))
                        }
                        // disabled={OrderData?.finalStatus === "delivered"}
                      />
                    </div>

                    {/* Receipt Image */}
                    <div
                      className={`${
                        OrderData?.finalStatus === "shipped" ||
                        OrderData?.finalStatus === "partially-shipped" ||
                        OrderData?.finalStatus === "partially-delivered" ||
                        OrderData?.finalStatus === "delivered"
                          ? ""
                          : "hidden"
                      }`}
                    >
                      <label className={`${"block text-gray-600 font-medium"}`}>
                        {OrderData?.finalStatus === "delivered" ? (
                          "Receipt Image"
                        ) : (
                          <>
                            Upload Receipt{" "}
                            <span className="text-gray-500 text-sm">
                              (Must have receiver's signature)
                            </span>
                          </>
                        )}
                      </label>

                      <div>
                        <label
                          //   htmlFor="special-input"
                          className={`${
                            OrderData?.finalStatus === "delivered"
                              ? "hidden"
                              : "cursor-pointer relative"
                          }`}
                        >
                          <div className="lg:mb-2 lg:text-[1.1rem] w-[100%] bg-[white] border-[1px] border-[#c6cfe5] rounded-[0.5rem] p-2 mb-4 flex items-center">
                            <div>
                              <PlusCircleFilled className="text-primary text-2xl flex items-center justify-center" />
                            </div>
                            <p className="text-[#9CA6C2] ml-2">Receipt Image</p>
                          </div>
                          <input
                            type="file"
                            className="hidden w-[100%] cursor-poniter"
                            // id="special-input"
                            accept="image/png, image/gif, image/jpeg"
                            onInput={imageHandler(
                              setImageURL,
                              setCourierReceiptImg
                            )}
                            // onChange={handleImageUpload}
                          />
                        </label>
                        <div
                          className={`relative mb-2 flex items-center justify-center bg-[#F8F8F8] p-3
                          ${imageURL !== null ? "" : "hidden"}`}
                        >
                          <img
                            onClick={() => {
                              // setIShow(true);
                            }}
                            src={imageURL}
                            className="w-[13rem] h-[6rem]"
                            //   src={GFront}
                            alt=""
                          />
                          <div
                            className={`${
                              OrderData?.finalStatus === "delivered"
                                ? "hidden"
                                : "absolute bottom-0 right-0 bg-white cursor-pointer"
                            }`}
                            onClick={() => {
                              setImageURL(null);
                            }}
                          >
                            <DeleteFilled
                              className="sm:w-[3rem] w-[2rem]"
                              style={{ fontSize: "30px", color: "#1BA397" }}
                              onClick={() => {
                                setCourierReceiptImg(null);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-x-3 ">
                    {/* Shipped Via */}
                    <div
                      className={`${
                        OrderData?.finalStatus === "shipped" ||
                        OrderData?.finalStatus === "partially-shipped" ||
                        OrderData?.finalStatus === "delivered" ||
                        OrderData?.finalStatus === "partially-delivered"
                          ? "pointer-events-none"
                          : ""
                      }`}
                    >
                      <label className="block text-gray-600 font-medium">
                        Shipped Via
                      </label>
                      <Select
                        className="w-full mt-1 wow"
                        placeholder="Select a courier"
                        value={courierName}
                        onChange={(value) => setCourierName(value)}
                        options={[
                          { label: "FedEx", value: "FedEx" },
                          { label: "DHL Express", value: "DHL Express" },
                          { label: "UPS", value: "UPS" },
                          {
                            label: "USPS (United States Postal Service)",
                            value: "USPS (United States Postal Service)",
                          },
                          { label: "Blue Dart", value: "Blue Dart" },
                          { label: "DTDC Courier", value: "DTDC Courier" },
                          { label: "India Post", value: "India Post" },
                          { label: "Canada Post", value: "Canada Post" },
                          { label: "TNT Express", value: "TNT Express" },
                          {
                            label: "Amazon Logistics",
                            value: "Amazon Logistics",
                          },
                          { label: "Self-Delivery", value: "Self-Delivery" },
                          { label: "Local Courier", value: "Local Courier" },
                          {
                            label: "Other (Specify)",
                            value: "Other (Specify)",
                          },
                        ]}
                      />
                    </div>

                    {/* Receipt No */}
                    <div
                      className={`${
                        OrderData?.finalStatus === "shipped"
                          ? "pointer-events-none"
                          : ""
                      }`}
                    >
                      <label className="block text-gray-700 font-medium">
                        Receipt No.
                      </label>
                      <input
                        className="w-full mt-1 bg-[#F6F4F4] p-3"
                        placeholder="Enter Receipt No."
                        value={courierReceiptNo}
                        onChange={(e) => setCourierReceiptNo(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="flex justify-between">
                  <span className="text-sm font-semibold">Status</span>
                  {(() => {
                    const firstStatus = data?.invOrder?.finalStatus;
                    const cancelledBy = data?.invOrderStatuses?.[0]?.userId
                      ? "buyer"
                      : "vendor"; // Get who cancelled

                    let label = statusStyles[firstStatus]?.label || firstStatus;
                    if (firstStatus === "cancelled") {
                      label =
                        cancelledBy === "vendor"
                          ? "Vendor Cancelled"
                          : "Buyer Cancelled";
                    }

                    const { bg, text } = statusStyles[firstStatus] || {
                      bg: "bg-gray-100",
                      text: "text-gray-800",
                    };

                    return (
                      <div
                        className={`${bg} ${text} rounded-full pl-3 pr-3 p-1 text-center font-semibold capitalize`}
                      >
                        {label}
                      </div>
                    );
                  })()}

                  {/* <div
                    className={`${
                      data?.invOrder?.finalStatus === "awaited-ps"
                        ? "bg-gray-100 text-gray-800" // Awaited PS
                        : data?.invOrder?.finalStatus === "ps-rejected"
                        ? "bg-red-100 text-red-800" // PS Rejected
                        : data?.invOrder?.finalStatus === "ps-approved" ||
                          data?.invOrder?.finalStatus === "vendor-accepted-quot"
                        ? "bg-green-100 text-green-800" // PS Approved
                        : data?.invOrder?.finalStatus === "submitted" ||
                          data?.invOrder?.finalStatus === "re-submitted" ||
                          data?.invOrder?.finalStatus === "quotation"
                        ? "bg-blue-200 text-blue-700" // Submitted or Re-Submitted
                        : data?.invOrder?.finalStatus === "in-progress"
                        ? "bg-yellow-100 text-[#e0aa36]" // In Progress
                        : data?.invOrder?.finalStatus === "partial"
                        ? "bg-orange-100 text-orange-800" // Partial
                        : data?.invOrder?.finalStatus === "partially-shipped"
                        ? "bg-purple-200 text-purple-800" // Partially Shipped
                        : data?.invOrder?.finalStatus === "shipped"
                        ? "bg-purple-100 text-purple-800" // Shipped
                        : data?.invOrder?.finalStatus === "partially-delivered"
                        ? "bg-teal-200 text-teal-800" // Partially Delivered
                        : data?.invOrder?.finalStatus === "delivered"
                        ? "bg-teal-100 text-teal-800" // Delivered
                        : data?.invOrder?.finalStatus === "delivered-issue"
                        ? "bg-pink-100 text-pink-800" // Delivered with Issue
                        : data?.invOrder?.finalStatus === "recieved"
                        ? "bg-indigo-100 text-indigo-800" // Received
                        : data?.invOrder?.finalStatus === "cancelled" ||
                          data?.invOrder?.finalStatus === "vendor-rejected-quot"
                        ? "bg-red-200 text-red-800" // Cancelled
                        : "bg-gray-100 text-gray-800" // Default Style
                    } rounded-full pl-4 pr-4 p-1 text-center font-semibold capitalize text-[0.95rem]`}
                  >
                    {data?.invOrder?.finalStatus === "awaited-ps"
                      ? "Awaited PS"
                      : data?.invOrder?.finalStatus === "ps-rejected"
                      ? "PS Rejected"
                      : data?.invOrder?.finalStatus === "ps-approved"
                      ? "PS Approved"
                      : data?.invOrder?.finalStatus === "submitted"
                      ? "Submitted"
                      : data?.invOrder?.finalStatus === "re-submitted"
                      ? "Re-Submitted"
                      : data?.invOrder?.finalStatus === "in-progress"
                      ? "In Progress"
                      : data?.invOrder?.finalStatus === "partial"
                      ? "Partial"
                      : data?.invOrder?.finalStatus === "partially-shipped"
                      ? "Partially Shipped"
                      : data?.invOrder?.finalStatus === "shipped"
                      ? "Shipped"
                      : data?.invOrder?.finalStatus === "partially-delivered"
                      ? "Partially Delivered"
                      : data?.invOrder?.finalStatus === "delivered"
                      ? "Delivered"
                      : data?.invOrder?.finalStatus === "delivered-issue"
                      ? "Delivered Issue"
                      : data?.invOrder?.finalStatus === "recieved"
                      ? "Received"
                      : data?.invOrder?.finalStatus === "cancelled"
                      ? "Cancelled"
                      : data?.invOrder?.finalStatus === "vendor-accepted-quot"
                      ? "Quotation Accepted"
                      : data?.invOrder?.finalStatus === "vendor-rejected-quot"
                      ? "Quotation Rejected"
                      : data?.invOrder?.finalStatus}
                  </div> */}
                </div>
                {orderDetails?.slice(0, 7)?.map((item) => (
                  <div className="flex justify-between mt-2">
                    <span className="text-sm text-gray-700 font-medium">
                      {item.label}
                    </span>
                    <span className="text-sm font-semibold">{item.value}</span>
                  </div>
                ))}
                <div className="flex justify-between mt-3">
                  <span className="text-[0.95rem] font-bold">
                    Order Total Amount
                  </span>
                  <span className="text-primary font-bold text-[0.95rem]">
                    ${TotalAmount}
                  </span>
                </div>
              </div>
              <div className={`${QuotationFlow ? "hidden" : "bg-white p-4"}`}>
                {orderDetails?.slice(9)?.map((item, index) => (
                  <div key={index}>
                    {/* Show heading when the original array's index is 10 */}
                    {index === 1 && (
                      <div className="mt-2 mb-3">
                        <h3 className="text-lg font-semibold text-gray-800">
                          Payment Methods
                        </h3>
                      </div>
                    )}
                    <div className="flex gap-2 mt-2 items-center justify-center">
                      <span className="text-sm text-gray-700 font-medium w-1/3">
                        {item.label}
                      </span>
                      <span className="text-sm font-semibold bg-[#F6F4F4] w-2/3 p-2 capitalize">
                        {item.value}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
              <div className={`${QuotationFlow ? "hidden" : "bg-white p-4"}`}>
                {paymentDetails?.map((item, index) => (
                  <div key={index}>
                    {/* Show heading when the original array's index is 10 */}
                    {index === 0 && (
                      <div className="mt-2 mb-3">
                        <h3 className="text-lg font-semibold text-gray-800">
                          Payment Detail
                        </h3>
                      </div>
                    )}
                    <div className="flex gap-2 mt-2 items-center justify-center">
                      <span className="text-sm text-gray-700 font-medium w-1/3">
                        {item.label}
                      </span>
                      <span className="text-sm font-semibold bg-[#F6F4F4] w-2/3 p-2 capitalize">
                        {item.value}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-white p-4 sm:w-[40%] w-full">
              <h2 className="text-gray-700 font-bold text-[0.95rem]">
                Products Detail
              </h2>
              {/* {localCart.length > 0 && ( */}
              <div className="mx-auto w-full flex flex-col gap-2  mt-1 lg:max-w-2xl xl:max-w-4xl">
                {/* Quotations */}
                <div className={`${QuotationFlow ? "space-y-6" : "hidden"}`}>
                  {quotationData?.invOrderItems?.map((item) => {
                    const getMatchedRate = alteredPrices?.find((rate) => {
                      if (item?.invadvancepriceId) {
                        return (
                          rate?.invadvancepriceId === item?.invadvancepriceId
                        );
                      }
                      return rate?.invproductId === item?.invproductId;
                    });

                    return (
                      <div
                        className="w-full bg-[#F6F6F6] rounded-sm p-4 flex flex-col gap-4"
                        key={item.id}
                      >
                        <div className="flex gap-4">
                          <img
                            src={
                              item?.invproduct?.invproductgallaries?.find(
                                (gallery) => gallery?.isCoverImg
                              )?.image || defaultImage
                            }
                            alt={item?.invproduct?.name}
                            className="w-24 h-24 rounded object-cover"
                          />
                          <div>
                            <h2 className="text-[0.95rem] font-semibold">
                              {item?.invproduct?.name}
                            </h2>

                            <div className="flex justify-between items-center gap-12">
                              <p className="text-sm font-medium text-gray-600">
                                Order quantity
                              </p>
                              <p className="text-lg font-semibold">
                                {item?.actualUnits}
                              </p>
                            </div>

                            <div className="flex justify-between items-center gap-12 mt-1">
                              <p className="text-sm font-medium text-gray-600">
                                Current Rate
                              </p>
                              <p className="text-sm font-semibold">
                                $
                                {item?.invadvanceprice !== null
                                  ? item?.invadvanceprice?.price
                                  : item?.prodBasePrice}
                                /{item?.invproduct?.pricingUnit}
                              </p>
                            </div>
                            <div
                              className={`${
                                getMatchedRate?.newPrice !== null &&
                                getMatchedRate?.newPrice !== undefined
                                  ? "flex justify-between items-center gap-12 mt-1"
                                  : "hidden"
                              }`}
                            >
                              <p className="text-sm font-medium text-gray-600">
                                Revised Rate
                              </p>

                              <p className="text-sm font-semibold">
                                ${getMatchedRate?.newPrice}
                              </p>
                            </div>

                            <div
                              className={`${
                                user === "vendor-owner" &&
                                OrderData?.finalStatus === "quotation"
                                  ? "flex justify-between items-center gap-12 mt-1"
                                  : "hidden"
                              }`}
                            >
                              <p className="text-sm font-medium text-gray-600">
                                Revised Rate
                              </p>
                              <input
                                type="number"
                                value={item?.revisedRate || ""} // Use the revisedRate value if it exists
                                onChange={(e) => {
                                  const updatedRate = e.target.value;
                                  // Update the revisedRate for the specific item in quotationData state
                                  const updatedItems =
                                    quotationData?.invOrderItems?.map(
                                      (orderItem) =>
                                        orderItem.id === item.id
                                          ? {
                                              ...orderItem,
                                              revisedRate: updatedRate,
                                            }
                                          : orderItem
                                    );
                                  setQuotationData({
                                    ...quotationData, // Keep the other parts of the state intact
                                    invOrderItems: updatedItems, // Update only invOrderItems
                                  });
                                }}
                                className="w-1/3 bg-white rounded p-1 text-center"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="border-t border-gray-200 pt-2">
                          <p className="text-right text-lg font-semibold text-gray-800">
                            ${item?.totalAmount}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* Products */}
                <div className={`${!QuotationFlow ? "space-y-6" : "hidden"}`}>
                  {quotationData?.invOrderItems?.map((item) =>
                    // <ProductCard
                    //   key={item.id}
                    //   item={item}
                    //   updateQuotationData={updateQuotationData}
                    // />
                    (() => {
                      const productData = {
                        name: item?.invproduct?.name,
                        image:
                          item?.invproduct?.invproductgallaries?.find(
                            (gallery) => gallery?.isCoverImg
                          )?.image || defaultImage,
                        quantity: item?.actualUnits,
                        totalAmount: item?.totalAmount,
                        invadvanceprice: item?.invadvanceprice,
                        basePrice: item?.prodBasePrice,
                        unit: item?.invproduct?.pricingUnit,
                        discount: item?.discountApplied,
                        tax: item?.taxApplied,
                        delivery: item?.calcDeliveryFee,
                        finalStatus:
                          item?.invorderitemstatuses?.find(
                            (status) => status.isCurrent
                          )?.status || null,
                        partialQtyDelivered:
                          item?.invorderitemstatuses?.find(
                            (status) => status.isCurrent
                          ) || null,
                        buyerUserId: data?.buyerUser?.id,
                        lastRecieved: item?.invorderitemstatuses
                          ?.filter(
                            (status) => status?.status === "partially-recieved"
                          )
                          ?.reduce(
                            (latest, status) =>
                              new Date(status.updatedAt) >
                              new Date(latest.updatedAt)
                                ? status
                                : latest,
                            { updatedAt: new Date(0), partialQtyDelivered: 0 } // Default to avoid undefined
                          ),
                      };

                      return (
                        <div
                          className="w-full bg-[#F6F6F6] rounded-sm p-4 flex flex-col gap-4"
                          key={item.id}
                        >
                          <div className="flex gap-4">
                            <img
                              src={productData.image}
                              alt={productData.name}
                              className="w-24 h-24 rounded object-cover"
                            />
                            <div className=" w-full">
                              <h2 className="text-[0.95rem] font-semibold">
                                {productData.name}
                              </h2>
                              <p className="text-sm text-gray-500">
                                $
                                {productData.invadvanceprice?.price ??
                                  productData.basePrice}
                                /{productData.unit}
                              </p>

                              <div className="flex justify-between items-center gap-12">
                                <p className="text-sm font-medium text-gray-600">
                                  Status
                                </p>
                                <p className="text-sm font-semibold capitalize">
                                  {productData?.finalStatus}
                                </p>
                              </div>
                              <div className="flex justify-between items-center gap-12">
                                <p className="text-sm font-medium text-gray-600">
                                  Order quantity
                                </p>
                                <p className="text-sm font-semibold">
                                  {productData.quantity}
                                </p>
                              </div>

                              <div
                                className={`${
                                  productData?.finalStatus ===
                                    "partially-in-progress" ||
                                  productData?.finalStatus ===
                                    "buyer-partial-accepted" ||
                                  productData?.finalStatus ===
                                    "partially-shipped" ||
                                  productData?.finalStatus ===
                                    "partially-delivered" ||
                                  productData?.finalStatus ===
                                    "partially-recieved"
                                    ? "flex justify-between items-center gap-12"
                                    : "hidden"
                                }`}
                              >
                                <p className="text-sm font-medium text-gray-600">
                                  {productData?.lastRecieved?.status ===
                                    "partially-in-progress" ||
                                  productData?.lastRecieved?.status ===
                                    "buyer-partial-accepted"
                                    ? "Processed"
                                    : productData?.lastRecieved?.status ===
                                      "partially-shipped"
                                    ? "Shipped"
                                    : productData?.lastRecieved?.status ===
                                      "partially-delivered"
                                    ? "Delivered"
                                    : "Received"}{" "}
                                  Quantity
                                </p>

                                <p className="text-sm font-semibold">
                                  {
                                    productData?.lastRecieved
                                      ?.partialQtyDelivered
                                  }
                                </p>
                              </div>
                              <div
                                className={`${
                                  productData?.finalStatus ===
                                    "partially-in-progress" ||
                                  productData?.finalStatus ===
                                    "buyer-partial-accepted" ||
                                  productData?.finalStatus ===
                                    "partially-shipped" ||
                                  productData?.finalStatus ===
                                    "partially-delivered" ||
                                  productData?.finalStatus ===
                                    "partially-recieved"
                                    ? "flex justify-between items-center gap-12"
                                    : "hidden"
                                }`}
                              >
                                <p className="text-sm font-medium text-gray-600">
                                  {productData?.finalStatus ===
                                    "partially-in-progress" ||
                                  productData?.finalStatus ===
                                    "buyer-partial-accepted"
                                    ? "Processed"
                                    : productData?.finalStatus ===
                                      "partially-shipped"
                                    ? "Shipped"
                                    : productData?.finalStatus ===
                                      "partially-delivered"
                                    ? "Delivered"
                                    : "Received"}{" "}
                                  Quantity
                                </p>

                                <p className="text-sm font-semibold">
                                  {
                                    productData?.partialQtyDelivered
                                      ?.partialQtyDelivered
                                  }
                                </p>
                              </div>

                              {user === "vendor-owner" &&
                                (OrderData?.finalStatus === "submitted" ||
                                  OrderData?.finalStatus ===
                                    "partially-recieved") && (
                                  <Checkbox
                                    className={`${
                                      productData?.finalStatus === "recieved"
                                        ? "hidden"
                                        : "checkk4 mt-2"
                                    }`}
                                    onChange={(e) => {
                                      const updatedRate = e.target.checked;
                                      // Update the revisedRate for the specific item in quotationData state
                                      const updatedItems =
                                        quotationData?.invOrderItems?.map(
                                          (orderItem) =>
                                            orderItem.id === item.id
                                              ? {
                                                  ...orderItem,
                                                  partial: updatedRate,
                                                }
                                              : orderItem
                                        );
                                      setQuotationData({
                                        ...quotationData, // Keep the other parts of the state intact
                                        invOrderItems: updatedItems, // Update only invOrderItems
                                      });
                                    }}
                                    // onChange={handlePartialChange}
                                    checked={item?.partial}
                                  >
                                    <label className="text-sm font-medium text-gray-600">
                                      Send Partial Order
                                    </label>
                                  </Checkbox>
                                )}

                              {item?.partial && (
                                <div className="bg-white p-2 mt-4">
                                  <div className="flex items-center gap-4 w-full ">
                                    <p className="text-sm font-medium text-gray-600 flex-shrink-0 w-2/3 px-2">
                                      Quantity Sending
                                    </p>
                                    <input
                                      type="number"
                                      onChange={(e) => {
                                        const updatedRate = Number(
                                          e.target.value
                                        ); // Convert input value to a number

                                        const updatedItems =
                                          quotationData?.invOrderItems?.map(
                                            (orderItem) => {
                                              if (orderItem.id === item.id) {
                                                const exceedsUnits =
                                                  updatedRate >
                                                  orderItem.actualUnits; // Check if value is greater than actual units

                                                return {
                                                  ...orderItem,
                                                  partialQuantity: updatedRate,
                                                  error: exceedsUnits, // Add error flag if it exceeds actual units
                                                };
                                              }
                                              return orderItem;
                                            }
                                          );

                                        setQuotationData({
                                          ...quotationData,
                                          invOrderItems: updatedItems,
                                        });
                                      }}
                                      value={item?.partialQuantity || ""}
                                      // onChange={handleQuantityChange}
                                      // onBlur={handleQuantityBlur}
                                      className="w-1/3 bg-[#F0F0F0] rounded p-2 text-center"
                                    />
                                  </div>
                                  {item?.error && (
                                    <p className="text-red-600 ml-2 text-sm">
                                      Ordered Quantity is Exceeded{" "}
                                    </p>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="border-t border-gray-200 pt-2 flex items-center justify-between">
                            {buyerUserId === productData?.buyerUserId &&
                            productData?.finalStatus === "delivered" &&
                            !QuotationFlow ? (
                              <div
                                onClick={() => {
                                  dispatch({ type: "Product", num: item });
                                  router("/Inventory/Order/Return");
                                }}
                                className="text-red-600 font-semibold text-[0.94rem] cursor-pointer"
                              >
                                Having issue?
                              </div>
                            ) : null}

                            {/* Total amount displayed on the right side */}
                            <div className="text-right text-[1.1rem] font-bold text-gray-800 flex-grow">
                              ${productData.totalAmount}
                            </div>
                          </div>
                        </div>
                      );
                    })()
                  )}
                </div>
              </div>
              {/* )} */}
            </div>
          </div>

          {/* <div className="grid grid-cols-2 gap-4 mt-4 bg-white rounded-md">
            <div className="bg-white p-4">
              <div className="flex justify-between">
                <span className="text-sm font-semibold">Status</span>
                <span className="text-gray-700 font-bold text-[0.95rem]">
                  Partial Dispatched
                </span>
              </div>
              <div className="flex justify-between mt-2">
                <span className="text-sm text-gray-700 font-medium">Date</span>
                <span className="text-sm">06/02/2024 6:20pm</span>
              </div>
              <div className="flex justify-between mt-2">
                <span className="text-sm text-gray-700 font-medium">
                  Quantity
                </span>
                <span className="text-sm font-semibold">1100</span>
              </div>
              <div className="flex justify-between mt-2">
                <span className="text-sm text-gray-700 font-medium">
                  Amount
                </span>
                <span className="text-sm font-semibold">$4800.6</span>
              </div>
              <div className="flex justify-between mt-2">
                <span className="text-sm text-gray-700 font-medium">TAX</span>
                <span className="text-sm font-semibold">$20</span>
              </div>
              <div className="border-t mt-2 pt-2 flex justify-between">
                <span className="font-bold">Total Amount</span>
                <span className="font-bold">$4820</span>
              </div>
            </div>

            <div className="bg-white p-4">
              <div className="flex justify-between">
                <span className="text-sm text-gray-700 font-medium ">
                  Shipped Via
                </span>
                <span className="text-sm font-semibold">Trackon</span>
              </div>
              <div className="flex justify-between mt-2">
                <span className="text-sm text-gray-700 font-medium ">
                  Shipment no.
                </span>
                <span className="text-sm font-semibold">89898989898</span>
              </div>
              <div className="flex justify-between mt-2 ">
                <span className="text-sm text-gray-700 font-medium">
                  Receipt no.
                </span>
                <span className="text-sm font-semibold">898889888</span>
              </div>
              <div className="flex gap-6">
                <div className="flex-1 mt-2 flex-col">
                  <div className="text-sm text-gray-700 font-medium mb-4">
                    Image
                  </div>
                  <img
                    src="data:image/jpeg;base64,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"
                    alt="Shipment"
                    className="w-full h-20 rounded"
                  />
                </div>
                <div className="flex-1 justify-between mt-2 flex-col">
                  <div className="text-sm text-gray-700 font-medium mb-4">
                    Receiver Signature
                  </div>
                  <img
                    src="data:image/png;base64,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"
                    alt="Signature"
                    className="w-full h-20"
                  />
                </div>
              </div>
            </div>
          </div> */}

          {/* <div className="grid grid-cols-2 gap-4 mt-4 bg-white">
            <div className="bg-white p-4">
              <h3 className="text-lg font-bold">Naturel Red Apple</h3>
              <div className="flex justify-between mt-2">
                <span className="text-sm font-medium">MRP</span>
                <span className="text-sm font-semibold">$25</span>
              </div>
              <div className="flex justify-between mt-2">
                <span className="text-sm font-medium">Order Quantity</span>
                <span className="text-sm font-semibold">1200 Pc</span>
              </div>
              <div className="flex justify-between mt-2">
                <span className="text-sm font-medium">Ordered On</span>
                <span className="text-sm font-semibold">6/3/2024 6:20pm</span>
              </div>
              <div className="flex justify-between mt-2">
                <span className="text-sm font-medium">Order ID</span>
                <span className="text-sm font-semibold">89855589889</span>
              </div>
              <div className="flex justify-between mt-2">
                <span className="text-sm font-medium">Pending Quantity</span>
                <span className="text-sm font-semibold">100 Pc</span>
              </div>
              <div className="mt-4 bg-[#F4F4F4] p-4">
                <Checkbox label="Send Partial Order" className="checkk4">
                  Send Partial Order{" "}
                </Checkbox>
                <input
                  type="text"
                  placeholder="Send quantity"
                  className="mt-2 p-2 border rounded w-full"
                />
              </div>
              <div className="flex justify-between mt-4">
                <span className="text-sm font-medium">Amount</span>
                <span className="text-sm font-semibold">$ 43.232</span>
              </div>
              <div className="flex justify-between mt-2">
                <span className="text-sm font-medium">Tax</span>
                <span className="text-sm font-semibold">$12.03</span>
              </div>
              <div className="border-t mt-2 pt-2 flex justify-between">
                <span className="font-bold">Total Amount</span>
                <span className="font-bold">$4820</span>
              </div>
            </div>

            <div className="bg-white p-4">
              <h3 className="text-lg font-bold text-red-500 mb-1">
                Payment Status
              </h3>
              <div className="bg-[#F4F4F4] px-5 py-2">
                <p className="text-red-500 text-sm">10% Advance pending</p>
                <p className="text-sm mt-2">
                  $4050 will be paid within 30 days after delivery
                </p>
              </div>

              <div className="p-4 bg-[#F4F4F4] mt-5">
                <img
                  src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBxMTEhUTExIWFRUWGBgXFxgXFRgVFhcXFxgWFxUVFhUYHSggGBolHRgXITEhJSkrLi4uFx8zODMtNygtLisBCgoKDg0OGhAQGi0lHyUtLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLSstLf/AABEIAKgBLAMBIgACEQEDEQH/xAAbAAABBQEBAAAAAAAAAAAAAAADAAIEBQYBB//EADwQAAEDAgQDBgQFAwMEAwAAAAEAAhEDIQQSMUEFUWEGInGBkfATMqGxFELB0eFSYvEVcoIHFjPiIyVD/8QAGgEAAgMBAQAAAAAAAAAAAAAAAAECAwQFBv/EADARAAICAQQBAgMGBwEAAAAAAAABAhEDBBIhMUEiUQUTsTJhgaHB8BUjM3GR0eEU/9oADAMBAAIRAxEAPwCQSkKqY4LgpkK8pCkrtNsprXLjXwUwH1GJrbJPfKbmQAYuTAu0wEV5ACABEwExtaCm1KgOiGAgCwmQoldOovSqRzQBFeyyVOonVallFe8C5MAXKQyw+K2LkDqVjuL8RjEfFpVIhhYbWN5keChcZ48XuhtmDQc+pVR8fMQqZZL4R09No/Mv8FvTa93edJkgyTrebzruFIw9DMbWPnoJ9UDC1zlLMs89wOohaPhFDNTaQ1tjl2nWdDf/ACq1JnrcGlwxhbRS08NVEvYDAMlwGnjFgFf4LF1C0Z2nlPULR0ODmmC9gi3fYNCL6g+K5UxOWi4NaH6ZdLWuL6jr4hScpRZRqdPptRDZGP4+37+hU5lIp3Cr6eKa+7bdOXRS6T1enZ4/VaaemyvHPtBWlMrFOaECugzgX1VxpTE4JDHFcabp7Qk0QUDDZ0Kq9ELwgVjyQBGLk5i45iYAkAV1RBIToKUIGcKGnZkiUhg3hChPrOQAUDNg1kJrylVqnRBvCtKAxAIQvhofxYR6dYEIAZTauVRddz3XHoAYai5VdZda1CxVQMaXO0AlAIBiMU2kJeY5Dc+AVNiO0JJ7oDR4y6OfJZ3i3F3VKhcT4DkNgFAFYn/KyTyybpHUwaeEeZq2apnFnvsHdNY+3uyn4SiHwAZJtEGZGto181m8EYI2PKbr07s5hqTQ0uIzG9x+u/imrafNff7HQ2wgrr8CidweqxpOSxYXggwW5dTI+3VU9E1cXh2tacr3SBms124GbbfUdFvf+oHHabeHuZSEVKzvgM6B96pgaS0HzKg4PD0qdKnh2gFwYMzo+UmC7qTsAP1WdZVSUpfj1ZBRjlnbjSPIsThH03FlRpa4ag+7jqn0GiV6Z2l4IypTDYFv/G8ASHQJBGuQ6xG6xFLAxmDrPEyPuPFS3Ua8WOMHYsG2NSW8razt6LUdmqwZU1GUxYn9OiyTa40J0t5Kdh+KBjRlbLhzPd3vz5b7K6HB1ZZ8cMT3Pg93wYDoaR8wkEctpKxXaGm2jVeMwyukiHCQfAaLFf6ti8SA0vqFgLWQCWsBfIaC1vPmeSm/9vvZLKrCHA3g2IMQbKyeWL4OLps0seR7eb8ENr3Mql0WJuAtJT0B5iVWN4cALG0wDPQnXzKiVDiGBxaS5rdenkdAhTSF8RxT1lSpJr6F9TqXXaypcDxgO7r4a7mND6qwNVWWefy4Z4nU0DckzVI3XQ1BAMx0LrnIJKG+okMkPeEMFRmuuiOegAjnJhcEI1E1KwJWcIFV6bmQqiLGcc6V1iYEKti2s1KQ0rDVwmNIUB/FQVIpVARIKjuRoWmyVdGyY8JlUrmHbK48wVoMIB5SppPSYkBxz7rj6qbVaUNzEAS6Lgs5234hlY2mN7n7D9Vc0zCw3bKtmxBHIAfQH9VXkdRLsCuZRgSdUUCEyn9lJw9doBkX2I5rG7OpBpdkzhtUBwJ03gT4XK9T7NltRoAaXW2eTH915y38F5DhmkkTMkxA18F6b2VIoUxmu43yTDWjd1QjX+ClkzrHGn5OnDGskPoU/GcDUp4+KuZ7Gy+lAloc4WbOk5gPorPg1GoXZnOInp9wtfiGmo0EgARIG+UOb3idiTPoo2Bw7m1308g7pFjJkXzEcjF1inp/n0lx/YzRxShbbG8R4cCwuNQOGh3ObaHah3IEQvNO0LgxwqNNvlPM7XHMFeq8exAbhzIkyGgmLA6NeN2m0Haei8O4/iIc5oJguNjqLkev7LoQx7I7GVvK1G2DfWDtF11TQA++qrab7I1J/v6jwTKpZHN2zUcJc5vMNtOrZv3RmaQSvQWYWlVZ8ShLKrJLqTnlzattJd3musIIsdxeV5pw57S4SJgyebugJ+Ue7LZYOs0MOUNF4tYX0AOs/wA+SyzhCDlJc+5qx4nJraQsfjAMhYTkeMzCdRqC0j+ppkHyXWcRDhkBnyB6mduqOzs+ypTY05ixjnFve3eTJJ1gkaKdhuAQx0DK1upIEdNdfLpssUJ2+Lr9V/r99G1b0/VRXnDUqgOXICBu9rXE8yJj05IVYPpggiTJIk6ixtAvqr9nACBnbBIE5dGuEiXNJGoBNjzOiqsXhy3NILTrlkixmCP6mrqYr29lWeEMsafJCp/Ed+aPAIlRlRrouVosDhWDDtrEABw+rTDvsqzF46iKtOmZHxMxzyO7lbO+piYHOFhWfJ83a+v3/wBKVj08I3tRUHiEGHCPcIgfNwVDp1WvcRGbl+6n4Xhr2ua2WsYZgvMNvtK6CurKs2hwZP6fpf5DmtXHrtZpa4tJBjcXCA56Zw5wlCTjLtDtU5qaxy5UckILZccAggodVxQBzFVQ0ErKYvGFzlccYqQxZsmSq5s16dK7J1Ag6qyw4tYqoaIEypVGrZQjyegwSuJ6PRrwF11SVnhjHJ34x3NbLPH0XLiu5lR/inc1W16lRlT4oMt1cB8wFh5jooyltVpEowvyaxziV0HmqJmPJAc0yDoU2tjyBJKTyRStko4pSe1FxVfC8/7QVSaziRr/AIUrGcceTYqkx2LNR0nVUTybuKNmPD8t3YzPYBNz8hCYDonG6gaEy04LWyuk6fc7Beg8GxQqGm2IBvU8Bc+RIDfBeXUXQRC0nBuJfDBdNx7AAWXPh3co6Wmyemj0LjXaAU/hBhuXBriJ0af/AGVhwvjlMvc978xBDgAObbCemWD5815czGOtU2Em5Bh1jYbT+6FS4iWG2rZBMgg2gRG9zfTRX6eDguDTnjjcVH8za9q+NMPxXA/mgDbKBmAt/vn15LyjieJL3Ek5r6nU9T1Vpj8VLHSdYI8hH2VHSwz6mYsaXZGl7o/K0EAuPS4VvLfJyNdNQqKHtcpFMDKTuFDaURjo9/dFGZSLfAVTn5kzzPOTre0HyC09DFHKItLmk9ZiAB4T6rH0TtOmu496ehVvg8Y4NyQC0vEEyCI7og7AtJ15OUXG2jfhyUjb4bEuadTDg3n8peRmA30d9RqtPwBwrOLC0F2YgCYAiJJI3+WY8tAvPRxJz4OYjuim0Nt3e/qIiTLut+q2nZfjcVG2j5iRYElxm4AiYP2VWOKguvb6JfodLJGU4Nrs2/8ApLmMLJzC1iSY2kSbW6fqsBx/DkVIBktABnUEC0xzW2xvaVrRcCxE+BsfSfovP+0mPDqkh4aSYPgd+kfqtcct8GbQ4MrbckFo1f8A62qI+So4t6d1hI+6wFHHfELqjjakx2X/AHvIa39V6HwYTga7SJz1XN6XYyYWNpdlpotpipBaczxYy4WABta52VaxPe5mDM2sjikA4E9sgvcQJ/LEnlqvQGU6VXDkAmAbAjcbSFgcNw5zYi98vmNvHovTey5YMI4lpL2lwIMhwO0g6rZh4VMbltSfm0YvGmIGg2jlfXeVD+OOamdo3tLm2AgDzO8xpqqOyqY/jOJKcZ+6+hPGJHNL8S3moAASMBFnGonfimpHEtVeCEnEJDoBx2qCyyzWdaTFUszSsy4QSFXM04ZcB2vUujUsq5hUum6yijp4MlG1eRyQ0z4iWdaTgHHhJrCnGqBdDdifRZ9Rm+Uvdl+HC8j+4hvpZHZmGGmZadAebRsomOrkyfK+6fi8T3hO/sKsxFfN73GqyrdJ3I6MYqCpEeo8FQHuUmq5Khw6pU+RpjmbBXxKJpvojteiNKtMP2XqkgZwCZ2O2uqJW7L1W6PabA8tfVSolHHlXcStouAKO2oh1uHVqdyw+I7yCyqlVF0MtcPgshiYA3G4n0QWmRbc+7IBfZc+NCZdLNf2ujnEKpsPfJE4fxJ9KlUpMgfFs87lsEBnQXPqobjJTmWui6MGX+ZJyYJiIAhO1Ts6ZWnxRLoPi37babKdQqxodttxfMPfXWVVsff+JUujWuP1EiBMCCg0YnyXWGqgnXXQw0QZBMeVs2quMLxaHB097MTqducjmPELLGrBG22xIE3tqNU2pjoNj7Isk17nShqVDs3GK48amcOIOcQJn7C+vvSK7EY1r3Fx7oOWG7b5r7XWRr8RNo98k2jWJ1MqcaQS+IO6ga93Hyxgp06lrkgDQkXjnt6Jp7RvBJY0CQQc3eMa9L+SzucH62vrHNEpU3ua5wEtblDjawcTAg7kjbkhzfRlc3LktafFKhkyLkE90a848ldjtliXTmy3EOhoa5wBA2sbrNU6OhIgmDM6WsZBtMTGotyUxsib267SA6f7hlIPKHKScvclGKtN9kzH4t9S4aAPC8xsY0uoDiVNpUNL2m1rx0ixi+vMqZSY13ztPK570iNLXN5i+h8UWGtxZM6Tu6KcEodQlXb+HNJim8E7tdDXDw2Kh4jBkEgggjUHVHLOM1t7RVl6YaxU52CTP9MclUgtEP8AEKnxzO9KvqvDnDZV+LwrgLhJpkoyplSEdhQXUXg/KU9gdyKjTNUMqRtITKlQC2p2A1TXF0hrbuNgFK/A/CuTLyLnl0CucvYwxj7lZxKo9obmtmmBvbmhCqCIvMA/soHGqzi6XHw8OijU6xiekLLkjuds34GlHgl8SfMSR5a+arTU29+SfWq5jJ9lPwNMSXH8unihRpFrdk3A8OEy+51A/W60NBtoEG0AQYM/Qb+izLsQSTv9lccJxTvlBGmhOsQTed7CeSi7NOFRNbw4AjNlBEBpG+hBkER/nZTvwgIJMa5YLZJ5eRbGx08FA4aQQHAwdpP5hIIJv3coPhaOasuJuyUxJg5y4CHAWGcOkWEmQG7a6BNJmtyiiL+AaRllrTOp0DZEmfMeg1Wf452dpvLiRBt3rBwkwDbWReCNwrzhuLi5NiTLYMkGMtx1Ddr35LQ4DAUq05nS2Zg/ng/MZuGxETz6qcbDIsdero8U4r2fr0cpAzNfEEaiflzDrzS4vwf8PRpmperUJMbNaBp4yQvVuP4dzWlpAjm8/MZsWtFxaF532/e8mgHXyBwzbOBykX3NlKPXPZyNVpnj9S+yZcFOLCRKDmUo1O51SozuXBELlwFcaCTAuVa4Pgj362969EyMITyP0org5GFWFpMN2dpbjMBc95wMaTbQXFyBqnYnsuzZrmzp3wf3+qKNsdHnq0jMOxB5oLqqs+KcAq0pPzDpr4qpa2U6MeR5Iva1Q+kN1JpuQQEem1RZOHCD0KoDhM5bTEZoGsE2BiVKwtYSNNdCYJjn6281XufoJMD02Bt5C/RODo3GtunKLTCdE1OmaLBOBBvrlJjfKXCCTEHU2tfpAvcHgmucANTpOmhgyBe5OmnksjhK2hkz/EX5fyVrOyWKb8RrXE3IAgxE8weXgrcato0xnxdFqeBOZGawI1I0i2XlPrsmHD/MATmF5mLtLTBnWwInqtR2mcWUWseBmc4gzoMpmWzoZcPEdFkGVoIlxbNjsAJvY2iw9VLLS4Rq0s90bkC4nhi6IBkAlsQSeQkFQsNxOQG1O+3Y/mb4Fa+rw1grth+ZgjKRYOcBBaBOhJPeOgAWI41h/h4mswbPMA7A94fdZpT9XBRrMcHU15LKtRAggyDoevJ3I/QoRB8E3BPtkcZDrHpyKa4ksndrspPPaffNXwn4Zx8kK6DHqo1eo3SFGrvPNQXtPNWORWokuq9kaBAGXkgGieablKg2WKJpezoBrF24a4j6fou9oaxi2v1B/VVvCsd8KsJ0kwObTqFd8Zw4c0PZdp0/UHqox5TQS4aZ53jK5dMqOyorHiuFgkjzVKTBVdFsZ7STmUuk6GeKrQ9WNP5W+CVF8ZWOpuiN7+wrDA1ASSNL7xrbKQNSeRVZUYrDhlJxIjmZ3Pp7+iW00Ynybjhz6kD4ciJiwiHTaCCNPCbc1zjHEH1KQa8izm3OpkEOsdiYPT1m37K4J9MZPgB+Zs3OWBfkNP3WK4xjG1KlVskBrnaPECCYkSIHeAB6GydKKLM+dRDYLFtNSH/LY7Aki8zF419FpeH8TqZy0HuzGkDLJ84v9BZYXhuFecpeY0jTaT781tOEUXFzRmnnvN5v4n7XUkTxNy5Zt+L0QWsfPImxdmAnKD0mB5ry/tjhRUpP1sS5tog689NfUr0njNcBgnSACAANgIJPgOX0XnfarHy0iekXmwt9PFSkqkw7w8nmIKnYdpc0gIeDwReTs0HX9Ar2lhw0AAeAVUp0c/Bhc+X0D4dw4DlO83v+60OHptGjS6OsXt8x2G/7KNgMP3hm15C5+mi0WEwAbBd9Rp/x0WeU6OxhhGAsJw492o57WXBDWgCf+QuR5qwwvDjTzHK5oMn5vhzzv80eMrtOuWQ5gBJsNy49dlb8Pe8vOa7iMs5ZcOQBNtfG4UoNyZttqN+DL8ZwVnd0sGp3637sm0XXmvGMNkeSI8veq994pRPwSXOay2vIWsG2BMN1trsvHu1NFpGZpzfsZ2AhaZpRMOoxrNicq5RlmFHo1S0yPD1UVh2RAonFTtBLE2RGadOX8eX0QAiNd1TCJOovAI0G02PvX6K74PWhzJIiRynUE3mwB6hZ1nK3vwVjw83BOpm+s/upxbRrxtHsvbetmFHQd5pzGxlzW85EW+iw+MwIBY6HUw4ucM/eIGjGmY0zE2B+fwAPQxGam3OR3YibmwiJMffotTh8KytUb8SrmDhD2VNIZLmkARdoJE6kSJs2JU5N8lmxwhFrpWFFGj8Gi6mM9QRN3NuQQQSReIHLVee9qHg42rawyCPCmzXktOeKBr8mHDhTz5Xsc81A2RDoc4/LyJjUcrYjG1jVr1HgfM7bSB3R9AFlUXvbYaq440mTsLV1MWAn0U78OW4Yl2r3DfrOm+iJwrhmYZn92m25JtcT6+HsC4vijVIyiGNkNH6nqtMI+Tk5JLoqzTTDTR8phNJcVZtK1IjZSiCl0SMp7ahSoluIOIZOvkeSfguLvo9192utOx/lKoQ3UqsxlcOkEyqGyxKi2xdEVO9SIM6tJAPlzWZ4hhC0mQR0IhJtctNj6Kww/F3RlcA9vJwn7pWxcFCrSi/TwCLWbhn/AJH0z/aZHo7T1RWcMkDJVputuch5b2+qdk8fpYKJnVTuGVS1w96W3UV2Bqt1pu8QMw8ZbIXabrx6hOjXiyUz1vgnaluUUwYzwCbGBfw16DYc1VdpuC4bLUyE53RYiBmF5Lj0i0DXwWPwWJyRe9hy8ZnpItpG6l1sbO5Otzabax5n1Uab7Njx458sbw+o3LDrEb9ba67rW8HrQ8SRAdBBsbxIJ5e4WHqOAdI38dDOvr7hWtDiMWE6ibiLRe2v8KSgWQlGqNpxzizHPJa6WgR9dwddyvL+0WLz1coJvM9BOym8a4oA2Gk2sNLi5v70WYwlcuqEkyUT45MuXJFVBF9hKIAFlNpU94UTCiBf0lT6dadAQOe56ALG7ZdFon8PpFsEkDWGgAk73J3Vt8Mu+c26Ovry2CqMNVyCT0tmECTAJJ1KX4qq49wEDd32y9NdPVLa5M141fJoKYykNYcoH5SACfrYfVSOHYp7aha6STsLxvpvbmqAOIaCC9ojvPcTneZ/KNhpZGoYyq4gMa4NG9gTtJcdfVW4407Nm24s9Jx2GZVpEGZIMRzMW08NF4/x/DPux7crGmJi5sbmTeAPCy2mE7XCmwU3Ml03OaRN4nmqDtRiPjgvmPoNjOX8y0zakYcUZYlKM+jynEMyuIXZsj8VaM1tFDa5Ro4E/RNoNKcEGU5r0ApE1qm4dxPX62389T5lQsLg6z/kpuPlA9StLwvsVj61xT+G0mA55LRvYEwJtzUkrLFm2h+HYtzYLnTpbYmxE/X12UqtxbUAl7pbAAPITprvdTMN2PwlIj8Vj2ZtmMJqnmLU+70glWNPimBoADD4bO6PnqxA+U2Y3rNrKahyWv4jUaSKnhvBsTWmGloIuekmZdMfXYqyHD8PhjE/GeNGtHdDt5P6hCxXGK9aQXZacRlaMjIP9o5dVF4fVLqgpUSQ91nOIuBvb9lbHGjnZdTObtkyvUqVjBk8mtFh5ImI4BXp0fiubDD66xMKZxKkME2kWPa9xl7jUqNYTcTkaZc89FrHY1hpmrX+V7bjUCYEkWi8KdIz7jzNlIbmFyq0RZScQBmMEESbg2MGxCAavT9FEmBq0IEwbqL8BSaznHoh5HeyosmjLVyCoVRqlVWEXkuGsge5HVAqELKi9kNy613qn1EAhMiSA4ojanvRRWVOf8ozDOiAJtDHOb8r3BShxmpo4MfP9TQfqVVwF0NHNNBbRcM4nTNnUY/2Ej6CyKMRQNw97PGCFRZV2SpElmmvJf8A4droy1mm27Y8/UrgwdQXD2H/AJEHpqFRB3ROD/co5Jf+iRMxvDMS8/KD4PbrvvqiYPgtRjQSwydYgwPFRWYhwiHHpdSW8SqAQHm89ddUmrI/M9W4tGUSPmafS38p9Z7rFv2mBuVUniNT+o89T7/wu/6k/TNF/BV/KL1q2vBa06JF4Lj128lNwmPcBeelifJULeJ1Nj7I/hFPEqhvJsQenjCl8ssXxCVVRfUOIEm7TY2LoA8Y1N/spGOx1QgBuZxI1iG35DVZtvFKg1OtwdSPPzRP9Tqx8xG1vEb+9FJQof8AE5rpItqeCrOPyWtOs85nnZOxnAMVVMBuUGLF3lPQSCqk8Sqn/wDQ7Xm9tP0SdjKh1e47aneTaNFPaiuXxHM/YmVf+n9Vw71Wk2InvtOu2u0IVLsZhG3qYuY1DWk+GgUYumN430nn5ogbPMn9tNk1FexilkcnbLahwHhFM9+pVqHo0gQBf5jz+26lUeIcOpf+PAFx5udl8DYXCpQHQBFoi8A208EVtM7u1EHr6+H0CmolbkaD/vSs21ChhqABEZacm14zOE7BVWP45iq9qtepUnYu7o5w3Qabcygsw4sPHX1RWjbroPvbVOiNkahhtIAb9+UqW1jWDM7bUm5ERoPopTMKRr3em/nsPuomNoF5DNW6nw8VYocFbmrBNrPeWloEbN5f3O581ueAcADKbqjACckEglxy3Dh3XNhxveVB7N8BcSXVWEUzA7wtl1ym29rdIU/tDxI0qbqdOm1nxJpmGySHGwEX8yp0Rs82441n4pr6bajaZeCG1HZ4AIkB24PuV6vxSpSbw4AknOzI2NRo4D6JdmOzjXs/+RvejVzNTvE7eChcY4lQaKlEU55EGGyPzAag9FBRpkrujCtsjMcLa+SkmmDoL+KcKDW6kA8oulROyM/JycgZVYPpN2Mp7cKPFFDTPN6HEiHXADYywBaF1rBUu0ETM8tvRTaPCW1JykzqBH3Qvwz6JuO6LmBc8r8v3WE1Fc+nt9EFzFZueKju6CIvfrrZCfhz49RMfXROxUVpamhTX0UE0kWKhrK5GqK2oCgmmmFiYExrk4mVCDyEQV0xEohclCbWHNEbV92TAeCiBClOkIEFASamB8aJzT4JgSKbB1RG0moWfw9+/qnCppYdPZTEHbSHh94/dEbSGsz79+ijfF8OXkjNr68+g15piJDcPp4jUX3/AG+iIcPpbW/lZAp4k+R9hEdXnU28QP8AKdioKwjl5xaPc+iK2sPZ5Ra3j9FDdVbtBRaUnonYqJf4jkI8vfRL42lwJNtz5D9EDEYOqNGkD8xNoFpMHxA81bOptpw9r23y90DSOZ18/ZsSbK5SSD8K4d8QOe5+Rrbj+p19BNhzm6m0cO2YptJN9O84je+wVI7iZtYm8AA/YLY9m+H1abfi1MrXunJlOaWFtw4HuuBmfJWxpdFUrfYZnZ7NTPxXFj4aW2kQbOY5uocDJ8lc8Ew+CpjIC17g6SdTMa3HOdJTKrXVXB1S8CDy8bc90Gq2nTvAA0sQLKVX2R66LjG4sMpuLIbTuYIHqT15Kr7P8PdiHfHeGwLMDthsSOZUnhmAfiWtziKUzBIBcB8s8tJUzi3GWYcNyBrmmZAOpG3vmot+ETryyRjuINpUyJyv5AWE8jzWD4hSYXOcQSSSTMzJ3JUmpxgPkxFzIJA/yolfHMgnfxEeqdJIVuyHSGW4b9vVObSDhcN6ewodTibz5eiVOuJuddYkeSrstpkyjlFsjT1EyVBqVu86bX5/wlUrx8sj34IdOoebddx/CGNEJmEa5oc3uO/tIIE3iJvedFArYSsMz3Bz+6bWc2dBJF23O6SSyUaGyMMNTyF7TlzWmYykHRw5FNOGdIaGANvJAPnE6LiSVBZFDmODie7BtzLfsT7lAOHBEtMj3MhJJKhkc4c7JhwxSSRQrGuw/RBdhSupIoLBnDuGyYRHMJJJgdaTzRGuckkiwHio5EbUdySSUhBA53JEGbkkkmIIGP5D2UT4L+iSSaRGwgw53cUwlo5uPLVJJMVj6RqOsxhnlZa/s52cIpPxFWoWvZlLdC2ToLGReLpJK6EF2VZJstsbWBZkgPB7zuQjSDrFzbw8VT1KWaGMZLiYAG5O0pJK6RTE1nZDs83Dte/EkOLoaG5Zyxd2V3UfZXeIxWZ3Jo0HICwFvRcSSihtiqPgZtLbaaWVTw9hxNapmB+EyLwRmdawPIe9kkk30CNR2i4iKFBrGPawkRkBEwB9J0XnT8WL6nle3okkoLgnVgKlbNqBHT9Uys6BYiPRJJDGkRad58dyi0xe7mhJJR6Jha42Dh48kxlEf1hJJDA//9k="
                  alt="Apple"
                  className="w-full h-64 mt-4 rounded"
                />
              </div>
            </div>
          </div> */}
          <div className="flex items-center justify-center gap-6 mt-4 ">
            <button
              className={`${
                buyerUserId === data?.buyerUser?.id &&
                TotalAmount !== paidAmount 
                  ? "px-6 py-2 bg-primary text-white rounded-md w-[16rem]"
                  : "hidden"
              }`}
              onClick={() => {
                setMakePayment(true);
              }}
            >
              Make Payment
            </button>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center gap-6 mt-4">
        <button
          className={getButtonClassRed()}
          onClick={() => {
            if (user === "vendor-owner" && QuotationFlow) {
              changeQuotationStatus("vendor-rejected-quot");
              return;
            }
            if (
              user === "vendor-owner" &&
              OrderData?.finalStatus === "submitted"
            ) {
              changeStatus("cancelled");
              return;
            }
            if (user === "employee" && role === "Permanent Secretary") {
              setShowRejectModal(true);
              return;
            }

            if (buyerUserId === data?.buyerUser?.id) {
              changeStatus("cancelled");
              return;
            }
          }}
        >
          {user === "vendor-owner" && QuotationFlow
            ? "Reject"
            : user === "vendor-owner"
            ? "Cancel order"
            : user === "employee" && role === "Permanent Secretary"
            ? "Reject"
            : "Cancel order"}
        </button>
        <button
          className={getButtonClass()}
          onClick={() => {
            if (user === "vendor-owner" && QuotationFlow) {
              changeQuotationStatus("vendor-accepted-quot");
              return;
            }
            if (
              user === "vendor-owner" &&
              OrderData?.finalStatus === "submitted"
            ) {
              changeStatus("in-progress");
              return;
            }

            if (user === "employee" && role === "Permanent Secretary") {
              setShowVerify(true);
              // changeStatus("ps-approved");
              return;
            }
          }}
        >
          {user === "vendor-owner" && QuotationFlow
            ? "Accept"
            : user === "vendor-owner" &&
              data?.invOrder?.finalStatus === "submitted"
            ? "Confirm & Process"
            : user === "employee" && role === "Permanent Secretary"
            ? "Approve & Submit to vendor"
            : "Confirm & Process"}
        </button>
      </div>

      {showRejectModal && (
        <PSRejectModal
          setShow={setShowRejectModal}
          onSubmit={() => {
            changeStatus("ps-rejected");
          }}
          note={note}
          setNote={setNote}
        />
      )}

      {errorModal && <ErrorModal setShow={setErrorModal} err={err} />}
      {showFeedback && (
        <FeedBackModal
          setShow={setShowFeedback}
          setErrorModal={setErrorModal}
          setErr={setErr}
          setShowSuccessModal={setShowSuccessModal}
          setRoute={setRoute}
          data={data}
        />
      )}
      {showSuccessModal && (
        <SuccessModal setShow={setShowSuccessModal} err={err} route={route} />
      )}

      {showVerify && (
        <VerifyOrder
          setShow={setShowVerify}
          setShowErrorModal={setErrorModal}
          setErr={setErr}
          submit={() => {
            changeStatus("ps-approved");
          }}
          display={display}
          setDisplay={setDisplay}
          setSignature={setSignature}
          signature={signature}
          exceedPurchaseLimit={false}
          orderDetail={true}
        />
      )}

      {makePayment && (
        <PaymentModal
          data={data}
          setShow={setMakePayment}
          setShowErrorModal={setErrorModal}
          setShowSuccessModal={setShowSuccessModal}
          setErr={setErr}
          setRoute={setRoute}
          setRefetch={setRefetch}
          refetch={refetch}
        />
      )}
    </div>
  );
};

export default Main;
